import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InfoIcon from "@mui/icons-material/Info";
import SearchIcon from "@mui/icons-material/Search";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridRowId } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { Accordion, Button, ButtonGroup, Form } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { useHistory, useLocation, useParams } from "react-router";
import { CommonService } from "../../Service/CommonService";
import { CookieService } from "../../Service/CookieService";
import { InventoryApiService } from "../../Service/InventoryApiService";
import "../Dynamic/InventoryCSV.scss";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import Swal from "sweetalert2";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import ProofIcon from '../../assets/images/icons/ProofIcon.svg';
import Info from "../../assets/images/icons/Info.svg";
import ValuationHistory from '../../assets/images/icons/ValuationHistoryIcon.svg';
import WarehouseOffCanvas from "./WarehouseOffCanvas";
import { useRoute } from "../Common/route";
import {
  usePersistentState,
  usePagePersistence,
  markNavigationPreserve,
  consumeNavigationPreserve,
  clearNamespace,
} from "../../hooks/persistence";
import { AnyTxtRecord } from "dns";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import GridViewIcon from '@mui/icons-material/GridView';
import ListSharpIcon from '@mui/icons-material/ListSharp';
import Spinner from "../Common/Spinner";
import CheckIcon from '@mui/icons-material/Check';
import MultiSelectChipInput from "../Common/MultiSelectChipInput";
import HorizontalScrollIndicator from "../Common/HorizontalScrollIndicator";


import barrel_1_2_a from '../../assets/images/facilities_images/1-2/1_2_a.png';
import barrel_2_3_a from '../../assets/images/facilities_images/2-3/2_3_a.png';
import barrel_3_4_a from '../../assets/images/facilities_images/3-4/3_4_a.png';
import barrel_4_5_a from '../../assets/images/facilities_images/4-5/4_5_a.png';
import barrel_5_6_a from '../../assets/images/facilities_images/5-6/5_6_a.png';
import barrel_6_7_a from '../../assets/images/facilities_images/6-7/6_7_a.png';
import barrel_7_8_a from '../../assets/images/facilities_images/7-8/7_8_a.png';
import barrel_8_9_a from '../../assets/images/facilities_images/8-9/8_9_a.png';
import barrel_9_10_a from '../../assets/images/facilities_images/9-10/9_10_a.png';
import barrel_10_11_a from '../../assets/images/facilities_images/10-11/10_11_a.png';
import barrel_11_12_a from '../../assets/images/facilities_images/11-12/11_12_a.png';
import barrel_12_13_a from '../../assets/images/facilities_images/12-13/12_13_a.png';
import barrel_13_14_a from '../../assets/images/facilities_images/13-14/13_14_a.png';
import barrel_14_15_a from '../../assets/images/facilities_images/14-15/14_15_a.png';
import barrel_15_16_a from '../../assets/images/facilities_images/15-16/15_16_a.png';
import barrel_16_17_a from '../../assets/images/facilities_images/16-17/16_17_a.png';
import barrel_17_18_a from '../../assets/images/facilities_images/17-18/17_18_a.png';
import barrel_18_19_a from '../../assets/images/facilities_images/18-19/18_19_a.png';
import barrel_19_20_a from '../../assets/images/facilities_images/19-20/19_20_a.png';
import barrel_20_21_a from '../../assets/images/facilities_images/20-21/20_21_a.png';
import barrel_21_22_a from '../../assets/images/facilities_images/21-22/21_22_a.png';
import barrel_22_23_a from '../../assets/images/facilities_images/22-23/22_23_a.png';
import barrel_23_24_a from '../../assets/images/facilities_images/23-24/23_24_a.png';
import barrel_24_25_a from '../../assets/images/facilities_images/24-25/24_25_a.png';
import barrel_25_plus_a from '../../assets/images/facilities_images/25_plus/25_plus_a.png';
import DataGridLoader from "../Common/DataGridLoader";

interface FacilityBarrelSummary {
  facility: string;
  totalBarrels: number;
  wdtsFacilities: number;
  externalFacilities: number;
  noFacilityContainers: number;
}

const MyInventories: React.FC = () => {
  const route = useRoute()
  const location = useLocation();
  const currentPath = location.pathname;
  const [isLoading, setIsLoading] = useState(false);
  const [containerLoading, setContainerLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [filterResetKey, setFilterResetKey] = useState(0);
  // Define the localeText object based on the isLoading flag
  const localeText = {
    noRowsLabel: isLoading ? "Fetching records ..." : "No Record Found",
  };
  const history = useHistory();
  // Page-level persistence config: clearPageState() can be called from a
  // logout handler or "reset all data" flow to wipe the entire namespace.
  const { clearPageState } = usePagePersistence({ storageKey: "my-inventory" });
  const [search, setSearch] = useState("");
  const userRole = CookieService.getCookie("userRole");
  const { id } = useParams<{ id: string }>();
  const params =
    id === undefined && CommonService.isUser()
      ? CommonService.getCompanyId()
      : id;
  const [tableData, setTableData] = useState<any[]>([]);
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const filterRef = useRef<any>(null);
  const [inventoryCsvWithDocs, setInventoryCsvWithDocs] = useState<any>(null);
  const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);
  const [service, setService] = useState<string>("");
  const [totalCount, setTotalCount] = useState(0);
  const controllerRef = useRef<AbortController | null>(null);
  const facilityControllerRef = useRef<AbortController | null>(null);

 // Restore filters only when returning from a detail page; otherwise clear persisted filters.
  const _filterInitRef = useRef(false);
  if (!_filterInitRef.current) {
    _filterInitRef.current = true;
    if (!consumeNavigationPreserve("my-inventory")) {
      clearNamespace("my-inventory");
    }
  }

  // Persisted via sessionStorage so the active tab survives navigation and refresh.
  const [activeButton, setActiveButton] = usePersistentState<string>(
    "my-inventory", "activeTab", "barrel_lots"
  );
  const activeButtonRef = useRef(activeButton);

  const pushWithActiveTab = (path: string, state: any = {}) => {
    // Signal that MyInventories is navigating to a child view.
    // consumeNavigationPreserve() on the next mount will see this flag
    // and keep the filter storage intact instead of clearing it.
    markNavigationPreserve("my-inventory");

    history.replace({
      ...history.location,
      state: {
        ...(history.location.state as any || {}),
        activeTab: activeButtonRef.current,
      },
    });
    history.push(path, { ...state, fromInternal: true });
  };
  const [sortField, setSortField] = usePersistentState("my-inventory", "sortField", "");
  const [sortDirection, setSortDirection] = usePersistentState("my-inventory", "sortDirection", "asc");
  const [page, setPage] = usePersistentState("my-inventory", "page", 0);
  const [pageSize, setPageSize] = usePersistentState("my-inventory", "pageSize", 50);
  const [selectedLots, setSelectedLots] = React.useState<string[]>([]);
  const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
  const initialFilter = {
    age: null,
    lotNo: null,
    barrelOwnerName: null,
    batchId: null,
    title: null,
    companyName: null,
    producer: null,
    dsp: null,
    fillDate: null,
    isAvailableForSell: null,
    lotQuantity: null,
    initialQuantity: null,
    quantity: null,
    price: null,
    facility: null,
    rackhouse: null,
    barrelNumber: null,
    proof: null,
    containerCooperage: null,
    isFilled: null,
  };
  const gridWrapperRef = useRef(null);
  const [filter, setFilter] = usePersistentState<any>("my-inventory", "filter", initialFilter);
  const [gridView, setView] = useState<boolean>(false);
  const switchView = (view: "grid" | "table") => { setView(view === "grid"); };
  const [facilities, setFacilities] = useState<string[]>([]);
  const [selectedFacilities, setSelectedFacilities] = usePersistentState<string[]>("my-inventory", "selectedFacilities", []);
  const [facilitySummary, setFacilitySummary] = useState<FacilityBarrelSummary | null>(null);
  const [facilitySearch, setFacilitySearch] = useState("");
  const [openRowId, setOpenRowId] = React.useState(null);
  const toggleDropdown = (rowId) => {
    setOpenRowId(prev => (prev === rowId ? null : rowId));
  };
  const [gridLoading, setGridLoading] = useState(false);
  const [showFacilityDropdown, setShowFacilityDropdown] = useState(false);
  const [sortModel, setSortModel] = usePersistentState<any[]>("my-inventory", "sortModel", []);

  // Which filter sections are visible for each tab
  const filterVisibilityMap: Record<string, Record<string, boolean>> = {
    barrel_lots: {
      company: true,
      quantity: true,
      lotQuantity: true,
      initialQuantity: true,
      title: false,
      fillDate: true,
      rackhouse: true,
      age: false,
      barrelNumber: false,
      proof: false,
      containerCooperage: false,
      isAvailableForSell: false,
      barrelCost: false,
      sellCost: false,
      isFilled: false,
      description: false,
      productName: false,
      ttbType: false,
      ttbClass: false,
      location: false,
      barrelOwner: false,   // no owner column in container lots
      facility: true,
      lotNo: true,
      producer: true,
      dsp: false,
      mashBill: false,
    },
    barrels: {
      company: true,
      quantity: false,
      lotQuantity: false,
      initialQuantity: false,
      title: false,
      fillDate: true,
      rackhouse: true,
      age: true,
      barrelNumber: true,
      proof: true,
      containerCooperage: true,
      isAvailableForSell: true,
      barrelCost: false,
      sellCost: false,
      isFilled: true,
      description: true,
      productName: false,
      ttbType: false,
      ttbClass: false,
      location: false,
      barrelOwner: true,
      facility: true,
      lotNo: true,
      producer: true,
      dsp: true,
      mashBill: true,
    },
    product: {
      company: true,
      quantity: false,
      lotQuantity: false,
      initialQuantity: false,
      title: false,
      fillDate: false,
      rackhouse: true,
      age: false,
      barrelNumber: false,
      proof: false,
      containerCooperage: false,
      isAvailableForSell: false,
      barrelCost: false,
      sellCost: false,
      isFilled: false,
      description: false,
      productName: true,
      ttbType: true,
      ttbClass: true,
      location: true,
      barrelOwner: false,
      facility: true,
      lotNo: false,         // no lotNo in product tab
      producer: false,
      dsp: true,
      mashBill: true,
    },
    facilities: {
      company: false,
      quantity: true,
      lotQuantity: true,
      initialQuantity: true,
      title: false,
      fillDate: false,
      rackhouse: false,
      age: true,
      barrelNumber: false,
      proof: true,
      containerCooperage: false,
      isAvailableForSell: false,
      barrelCost: false,
      sellCost: false,
      isFilled: false,
      description: false,
      productName: true,
      ttbType: false,
      ttbClass: false,
      location: false,
      barrelOwner: false,
      facility: true,
      lotNo: true,
      producer: false,
      dsp: false,
      mashBill: true,
    },
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      // 2. Check if the click happened outside of the ref container
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenRowId(null); // Close the dropdown (use "" if your state uses empty strings)
      }
    }

    // 3. Bind the event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    
    // 4. Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openRowId]); // Re-run when dropdown state changes

  // Helper — returns true if the section should be visible for the current tab
  const isFilterVisible = (key: string): boolean => {
    const map = filterVisibilityMap[activeButton] ?? {};
    // If key not defined in map, default to showing it
    return map[key] !== false;
  };

  const handleIndividualReset = (field: string) => {
    const updated = {
      ...(filterRef.current ?? filter), 
      [field]: null,                    
    };
    filterRef.current = updated;
    setFilter(updated);
    setFilterResetKey(k => k + 1);
  };

  // For multiselect panel filters
  const handleMultiselectReset = (clearFn: () => void, field: string) => {
    clearFn();  // clears the panel array state (e.g. setPanelCompanies([]))

    const updated = {
      ...(filterRef.current ?? filter),
      [field]: null,
    };
    filterRef.current = updated;
    setFilter(updated);
  };

  const buildTabAwareFilter = (filterToClean: any, destinationTab: string) => {
    // Start from current filter state
    const base = { ...filterToClean };

    // For every key in filterVisibilityMap, if the destination tab
    // marks it as false (hidden), null it out in the filter
    const visibilityForTab = filterVisibilityMap[destinationTab] ?? {};

    // Map filter field keys to filterVisibilityMap keys
    const filterKeyToVisibilityKey: Record<string, string> = {
      companyName: "company",
      barrelOwnerName: "barrelOwner",
      facility: "facility",
      lotNo: "lotNo",
      producer: "producer",
      dsp: "dsp",
      mashBill: "mashBill",
      quantity: "quantity",
      title: "title",
      fillDate: "fillDate",
      lotQuantity: "lotQuantity",
      initialQuantity: "initialQuantity",
      rackhouse: "rackhouse",
      age: "age",
      barrelNumber: "barrelNumber",
      proof: "proof",
      containerCooperage: "containerCooperage",
      isAvailableForSell: "isAvailableForSell",
      barrelCost: "barrelCost",
      sellCost: "sellCost",
      isFilled: "isFilled",
      description: "description",
      productName: "productName",
      ttbType: "ttbType",
      ttbClass: "ttbClass",
      location: "location",
    };

    Object.entries(filterKeyToVisibilityKey).forEach(([filterKey, visKey]) => {
      if (visibilityForTab[visKey] === false) {
        base[filterKey] = null;
      }
    });

    // Now run through buildPanelFilter with the cleaned base
    return buildPanelFilter(base, destinationTab);
  };

  // Panel-level multiselect filters — all persisted via sessionStorage.
  const [panelCompanies, setPanelCompanies] = usePersistentState<string[]>("my-inventory", "panelCompanies", []);
  const [panelBarrelOwners, setPanelBarrelOwners] = usePersistentState<string[]>("my-inventory", "panelBarrelOwners", []);
  const [panelFacilities, setPanelFacilities] = usePersistentState<string[]>("my-inventory", "panelFacilities", []);
  const [panelLotNos, setPanelLotNos] = usePersistentState<string[]>("my-inventory", "panelLotNos", []);
  const [panelProducers, setPanelProducers] = usePersistentState<string[]>("my-inventory", "panelProducers", []);
  const [panelDsps, setPanelDsps] = usePersistentState<string[]>("my-inventory", "panelDsps", []);
  const [panelMashBills, setPanelMashBills] = usePersistentState<string[]>("my-inventory", "panelMashBills", []);

  // Search strings inside the panel dropdowns
  const [companySearch, setCompanySearch] = useState("");
  const [barrelOwnerSearch, setBarrelOwnerSearch] = useState("");
  const [panelFacilitySearch, setPanelFacilitySearch] = useState("");

  // Available options fetched from the dedicated filter options API
  const [allCompanies, setAllCompanies] = useState<string[]>([]);
  const [allBarrelOwners, setAllBarrelOwners] = useState<string[]>([]);
  const [allLotNos, setAllLotNos] = useState<string[]>([]);
  const [allProducers, setAllProducers] = useState<string[]>([]);
  const [allDsps, setAllDsps] = useState<string[]>([]);
  const [allMashBills, setAllMashBills] = useState<string[]>([]);

  // Derived: is any panel filter active?
  const isPanelFilterApplied = Boolean(
    (filter?.companyName && filter.companyName.length > 0) ||
    (filter?.barrelOwnerName && filter.barrelOwnerName.length > 0) ||
    (filter?.facility && filter.facility.length > 0) ||
    (filter?.lotNo && filter.lotNo.length > 0) ||
    (filter?.producer && filter.producer.length > 0) ||
    (filter?.dsp && filter.dsp.length > 0) ||
    (filter?.mashBill && filter.mashBill.length > 0)
  );
  // ────────────────────────────────────────────────────────────────────────────

  const BarrelImage = ({ fillDate }: { fillDate: string }) => {
    const { years, months } = CommonService.calculateAge(fillDate);
    const ageInYears = Number(years) + Number(months || 0) / 12;

    const getAgeIndex = (age: number) => {
      const years = Math.floor(age);
      if (years >= 25) return barrelImages.length - 1;
      if (years <= 1) return 0;
      return years - 1;
    };

    const selectedImage = useMemo(() => {
      const ageIndex = getAgeIndex(ageInYears);
      const images = barrelImages[ageIndex] || barrelImages[0];
      return images[Math.floor(Math.random() * images.length)];
    }, [ageInYears]);

    return <img src={selectedImage} alt="WhiskyBarrelBig" />;
  };

  const barrelImages = [
    [barrel_1_2_a], [barrel_2_3_a], [barrel_3_4_a], [barrel_4_5_a], [barrel_5_6_a],
    [barrel_6_7_a], [barrel_7_8_a], [barrel_8_9_a], [barrel_9_10_a], [barrel_10_11_a],
    [barrel_11_12_a], [barrel_12_13_a], [barrel_13_14_a], [barrel_14_15_a], [barrel_15_16_a],
    [barrel_16_17_a], [barrel_17_18_a], [barrel_18_19_a], [barrel_19_20_a], [barrel_20_21_a],
    [barrel_21_22_a], [barrel_22_23_a], [barrel_23_24_a], [barrel_24_25_a], [barrel_25_plus_a],
  ];

  const fetchContainerListing = async (page: any, size: any, filter: any, sortField: any, sortDirection: any) => {
    const controller = new AbortController();
    const signal = controller.signal;

    setSortField(sortField);
    setSortDirection(sortDirection);

    try {
      setContainerLoading(true);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;
      let lastSegment = "";

      if (currentPath.includes("/inventory")) {
        lastSegment = "inventory";
      } else if (currentPath.includes("/available-for-sell")) {
        lastSegment = "available-for-sell";
      } else if (currentPath.includes("/not-available-for-sell")) {
        lastSegment = "not-available-for-sell";
      } else if (currentPath.includes("/available-barrel")) {
        lastSegment = "available-barrel";
      } else if (currentPath.includes("/reserved-barrel")) {
        lastSegment = "reserved-barrel";
      }
      const cleanedFilter = buildTabAwareFilter(filter, activeButtonRef.current);
      const response: any = await InventoryApiService.getMyInventories(
        service,
        params,
        lastSegment,
        page,
        size,
        cleanedFilter,
        sortField, sortDirection,
        signal,
        activeButtonRef.current
      );

      setTableData(Object.values(response.data.content)); // Convert object to array
      setTotalCount(response.data.totalElements);
      setContainerLoading(false);
    } catch (error) {
      if (error?.name === "AbortError" || error?.code === "ERR_CANCELED") {
        return;
      }
      console.error("Error fetching data:", error);
      setContainerLoading(false);
    }
  }

  const fetchProductListing = async (page: any, size: any, filter: any, sortField: any, sortDirection: any) => {
    const controller = new AbortController();
    const signal = controller.signal;

    setSortField(sortField);
    setSortDirection(sortDirection);

    try {
      setProductLoading(true);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;
      let lastSegment = "";

      if (currentPath.includes("/inventory")) {
        lastSegment = "inventory";
      } else if (currentPath.includes("/available-for-sell")) {
        lastSegment = "available-for-sell";
      } else if (currentPath.includes("/not-available-for-sell")) {
        lastSegment = "not-available-for-sell";
      } else if (currentPath.includes("/available-barrel")) {
        lastSegment = "available-barrel";
      } else if (currentPath.includes("/reserved-barrel")) {
        lastSegment = "reserved-barrel";
      }
      const cleanedFilter = buildTabAwareFilter(filter, activeButtonRef.current);
      const responseProduct: any = await InventoryApiService.getMyBarrelsProduct(
        service,
        params,
        lastSegment,
        page,
        size,
        cleanedFilter,
        sortField, sortDirection,
        signal,
        activeButtonRef.current
      );
      const rowsWithIds = responseProduct.data.content.map((item: any, index: number) => ({
        ...item,
        id: item.id || index // Use existing id if available, otherwise fallback to index
      }));

      setTableData(rowsWithIds); // Set the table data with unique ids
      setTotalCount(responseProduct.data.totalElements);
      setProductLoading(false);
    } catch (error) {
      if (error?.name === "AbortError" || error?.code === "ERR_CANCELED") {
        return;
      }
      console.error("Error fetching data:", error);
      setProductLoading(false);
    }
  }

  const fetchFacilityListing = async (page: any, size: any, filter: any, sortField: any, sortDirection: any) => {
    const controller = new AbortController();
    const signal = controller.signal;

    setSortField(sortField);
    setSortDirection(sortDirection);

    try {
      setFacilityLoading(true);
      setGridLoading(true);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;
      let lastSegment = "";

      if (currentPath.includes("/inventory")) {
        lastSegment = "inventory";
      } else if (currentPath.includes("/available-for-sell")) {
        lastSegment = "available-for-sell";
      } else if (currentPath.includes("/not-available-for-sell")) {
        lastSegment = "not-available-for-sell";
      } else if (currentPath.includes("/available-barrel")) {
        lastSegment = "available-barrel";
      } else if (currentPath.includes("/reserved-barrel")) {
        lastSegment = "reserved-barrel";
      }
      const cleanedFilter = buildTabAwareFilter(filter, activeButtonRef.current);
      const responseFacilities: any = await InventoryApiService.getMyBarrelsFacilities(
        service,
        params,
        lastSegment,
        page,
        size,
        cleanedFilter,
        sortField, sortDirection,
        signal,
        activeButtonRef.current
      );

      setTableData(Object.values(responseFacilities.data.content));
      setTotalCount(responseFacilities.data.totalElements);
      setFacilityLoading(false);
      setGridLoading(false);
    } catch (error) {
      if (error?.name === "AbortError" || error?.code === "ERR_CANCELED") {
        return;
      }
      console.error("Error fetching data:", error);
      setFacilityLoading(false);
      setGridLoading(false);
    }
  }

  const exportInventoryData = async (page: any, size: any, filter: any, sortField: any, sortDirection: any) => {
    const controller = new AbortController();
    const signal = controller.signal;

    try {
      setIsLoading(true);

      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;
      let lastSegment = "";

      if (currentPath.includes("/inventory")) {
        lastSegment = "inventory";
      } else if (currentPath.includes("/available-for-sell")) {
        lastSegment = "available-for-sell";
      } else if (currentPath.includes("/not-available-for-sell")) {
        lastSegment = "not-available-for-sell";
      } else if (currentPath.includes("/available-barrel")) {
        lastSegment = "available-barrel";
      } else if (currentPath.includes("/reserved-barrel")) {
        lastSegment = "reserved-barrel";
      }

      if (activeButtonRef.current?.toLowerCase() === "product".toLowerCase()) {
        const cleanedFilter = buildTabAwareFilter(filter, "product");
        InventoryApiService.exportMyBarrelsProduct(
          service,
          params,
          lastSegment,
          cleanedFilter,
          sortField,
          sortDirection,
          signal,
          activeButtonRef.current
        );
        CommonService.Toast.fire({
          title: "Your export is in progress. We'll notify you when it's ready!",
          icon: "success",
        });
        setIsLoading(false);
      } else if (activeButtonRef.current?.toLowerCase() === "facilities".toLowerCase()) {
        const cleanedFilter = buildTabAwareFilter(filter, "facilities");
        InventoryApiService.exportMyBarrelsFacilities(
          service,
          params,
          lastSegment,
          cleanedFilter,
          sortField,
          sortDirection,
          signal,
          activeButtonRef.current
        );
        CommonService.Toast.fire({
          title: "Your export is in progress. We'll notify you when it's ready!",
          icon: "success",
        });
        setIsLoading(false);
      } else {
        //const lastSegment = currentPath.split("/").pop();
        const cleanedFilter = buildTabAwareFilter(filter, activeButtonRef.current);
        InventoryApiService.exportMyInventories(
          service,
          params,
          lastSegment,
          cleanedFilter,
          sortField,
          sortDirection,
          activeButtonRef.current
        );
        CommonService.Toast.fire({
          title: "Your export is in progress. We'll notify you when it's ready!",
          icon: "success",
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const fetchInventoryChangeRequests = async () => {
    try {
      setIsLoading(true);
      let response: any;
      if (currentPath === "/user/inventory-change-requests")
        response = await InventoryApiService.getInventoryChangeRequests(
          params,
          false
        );
      else response = await InventoryApiService.getAllInventoryChangeRequests();

      setTableData(Object.values(response.data));
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const fetchFacilityBarrelSummary = async (activeFilter?: any) => {
    try {
      let response;
      if (activeButtonRef.current === "facilities") {
        const cleaned = activeFilter ? buildTabAwareFilter(activeFilter, "facilities") : null;
        response = await InventoryApiService.getFacilityBarrelSummary(params, cleaned);
      }
      setFacilitySummary(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const createFakeEvent = (value: string): React.ChangeEvent<HTMLInputElement> => {
    return { target: { value }, } as React.ChangeEvent<HTMLInputElement>;
  };

  const validFacilities = facilities.filter(
    (f) => f && f.trim() !== ""
  );

  const cleanedSelectedFacilities = selectedFacilities.filter(
    (f) => f && f !== "All Facilities"
  );

  const toggleAllFacilities = () => {
    setSelectedFacilities((prev) =>
      prev.length === validFacilities.length
        ? []
        : validFacilities.filter(f => f !== "All Facilities")
    );
  };

  const toggleFacility = (facility: string) => {
    setSelectedFacilities((prev) => {
      if (prev.includes(facility)) {
        return prev.filter((f) => f !== facility);
      } else {
        return [...prev, facility];
      }
    });
  };

  const filteredFacilities = facilities
    .filter((facility) => facility && facility.trim() !== "")
    .filter((facility) => facility.toLowerCase().replace(/\s/g, "").includes(facilitySearch.toLowerCase().replace(/\s/g, "")));

  const getFacilityLabel = () => {
    const count = cleanedSelectedFacilities.length;
    const total = validFacilities.length;

    if (count === 0) return "Select Facility";

    if (count === total) return "All Facilities";

    if (count === 1) return cleanedSelectedFacilities[0];

    return `${cleanedSelectedFacilities[0]} +${count - 1}`;
  };

  useEffect(() => {
    filterRef.current = filter;
  }, [filter]);

  // Fetch filter options from the dedicated API (no more 9999 hack)
  useEffect(() => {
    const loadFilterOptions = async () => {
      try {
        // Backend derives companyId from JWT — SUPER_ADMIN gets all, others get their own company
        const response: any = await InventoryApiService.getInventoryFilterOptions(null);
        const opts = response.data;
        setAllCompanies(opts.companies || []);
        setAllBarrelOwners(opts.barrelOwners || []);

        // Use facilities from the filter options API as the primary source for the filter panel.
        const apiFacilities: string[] = opts.facilities || [];
        if (apiFacilities.length > 0) {
          setFacilities(apiFacilities);
          // Only initialise the selection on a fresh session (empty = no prior selection).
          // If the user already has a persisted selection we must NOT overwrite it —
          // that was the bug that cleared filter state on every page mount.
          setSelectedFacilities((prev) => (prev.length === 0 ? apiFacilities : prev));
        }

        setAllLotNos(opts.lotNos || []);
        setAllProducers(opts.producers || []);
        setAllDsps(opts.dsps || []);
        setAllMashBills(opts.mashBills || []);
      } catch (_) { /* silent — filter panel is non-critical */ }
    };
    loadFilterOptions();
  }, []);

  // Build the filter value from panel selections (comma-separated for multiselect).
  // Tab-aware: only apply filters supported by the current tab's backend query.
  const buildPanelFilter = (base: any, tab?: string) => {
    const currentTab = tab ?? activeButtonRef.current;
    const merged = { ...base };

    const toFilterValue = (selected: string[], allOptions: string[]): string | null => {
      if (selected.length === 0) return null;
      if (allOptions.length > 0 && selected.length >= allOptions.length) return null;
      return selected.join(",");
    };

    // multiselect panel filters (unchanged — these still read from state)
    if (currentTab !== "product") {
      merged.lotNo = toFilterValue(panelLotNos, allLotNos);
    } else {
      merged.lotNo = null;
    }

    merged.producer = toFilterValue(panelProducers, allProducers);
    merged.dsp = toFilterValue(panelDsps, allDsps);

    if (currentTab !== "product" && currentTab !== "barrel_lots") {
      merged.mashBill = toFilterValue(panelMashBills, allMashBills);
    } else {
      merged.mashBill = null;
    }

    if (currentTab !== "facilities") {
      merged.companyName = toFilterValue(panelCompanies, allCompanies);
    } else {
      merged.companyName = null;
    }

    if (currentTab === "barrels") {
      merged.barrelOwnerName = toFilterValue(panelBarrelOwners, allBarrelOwners);
    } else {
      merged.barrelOwnerName = null;
    }

    merged.facility = toFilterValue(panelFacilities, validFacilities);

    merged.quantity = base.quantity?.trim() ? base.quantity : null;
    merged.title = base.title?.trim() ? base.title : null;
    merged.fillDate = base.fillDate?.trim() ? base.fillDate : null;
    merged.lotQuantity = base.lotQuantity?.trim() ? base.lotQuantity : null;
    merged.initialQuantity = base.initialQuantity?.trim() ? base.initialQuantity : null;
    merged.rackhouse = base.rackhouse?.trim() ? base.rackhouse : null;
    merged.age = base.age?.trim() ? base.age : null;
    merged.barrelNumber = base.barrelNumber?.trim() ? base.barrelNumber : null;
    merged.proof = base.proof?.trim() ? base.proof : null;
    merged.containerCooperage = base.containerCooperage?.trim() ? base.containerCooperage : null;
    merged.isAvailableForSell = base.isAvailableForSell ?? null;
    merged.barrelCost = base.barrelCost ?? null;
    merged.sellCost = base.sellCost ?? null;
    merged.isFilled = base.isFilled ?? null;
    merged.description = base.description?.trim() ? base.description : null;
    merged.productName = base.productName?.trim() ? base.productName : null;
    merged.ttbType = base.ttbType?.trim() ? base.ttbType : null;
    merged.ttbClass = base.ttbClass?.trim() ? base.ttbClass : null;
    merged.location = base.location?.trim() ? base.location : null;

    return merged;
  };

  const handlePanelApply = () => {
    // Use ref values (latest typed input) merged with panel selections
    const base = filterRef.current ?? filter;
    const merged = buildPanelFilter(base);
    setFilter(merged); // only setState on Apply click
    filterRef.current = merged;

    if (activeButtonRef.current === "product") {
      fetchProductListing(page, pageSize, merged, "productName", sortDirection);
    } else if (activeButtonRef.current === "facilities") {
      fetchFacilityListing(page, pageSize, merged, "lotNo", sortDirection);
      fetchFacilityBarrelSummary(merged);
    } else {
      fetchContainerListing(page, pageSize, merged, "lotNo", sortDirection);
    }
  };

  const handlePanelClear = () => {
    setPanelCompanies([]);
    setPanelBarrelOwners([]);
    setPanelFacilities([]);
    setPanelLotNos([]);
    setPanelProducers([]);
    setPanelDsps([]);
    setPanelMashBills([]);
    setFilterResetKey(k => k + 1);
    filterRef.current = { ...initialFilter }; 

    const cleared = { ...initialFilter }; 

    setFilter(cleared);

    if (activeButtonRef.current === "product") {
      fetchProductListing(page, pageSize, cleared, "productName", sortDirection);
    } else if (activeButtonRef.current === "facilities") {
      fetchFacilityListing(page, pageSize, cleared, "lotNo", sortDirection);
      fetchFacilityBarrelSummary();
    } else {
      fetchContainerListing(page, pageSize, cleared, "lotNo", sortDirection);
    }
  };

  const togglePanelItem = (
    list: string[], setList: React.Dispatch<React.SetStateAction<string[]>>, value: string
  ) => {
    setList(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
  };

  const selectAllPanelItems = (
    options: string[], setList: React.Dispatch<React.SetStateAction<string[]>>, current: string[]
  ) => {
    const allSelected = options.length > 0 && current.length === options.length;
    setList(allSelected ? [] : [...options]);
  };
  // ────────────────────────────────────────────────────────────────────────────

  const getSpiritAgeFromFillDate = (fillDate: string | Date) => {
    if (!fillDate) return "Age N/A";

    const currentDate = new Date();
    const fill = new Date(fillDate);

    if (isNaN(fill.getTime())) return "Age N/A";

    let years = currentDate.getFullYear() - fill.getFullYear();
    let months = currentDate.getMonth() - fill.getMonth();

    // Adjust if current month is earlier
    if (months < 0) {
      years--;
      months += 12;
    }

    // Handle future fill dates
    if (years < 0) return "Age N/A";

    return `${years} years ${months} months`;
  };

  const getExportUrl = () => {
    exportInventoryData(page, pageSize, filter, sortField, sortDirection); // Ensure it returns a URL
  };

  useEffect(() => {
    if (
      currentPath === "/user/inventory-change-requests" ||
      currentPath === "/master/inventory-change-requests"
    ) {
      fetchInventoryChangeRequests();
    } else {
      // activeButtonRef.current is initialised from sessionStorage via usePersistentState,
      // so it correctly reflects the last active tab across navigation and refresh.
      const activeTab = activeButtonRef.current;
      if (activeTab === "product") {
        fetchProductListing(page, pageSize, filter, sortField || "productName", sortDirection);
      } else if (activeTab === "facilities") {
        fetchFacilityListing(page, pageSize, filter, sortField || "lotNo", sortDirection);
        fetchFacilityBarrelSummary(filter);
      } else {
        // default: "barrel_lots" or "barrels"
        fetchContainerListing(page, pageSize, filter, sortField || "lotNo", sortDirection);
      }

      // Pre-load facility list for the filter panel
      if (CommonService.isAdmin() && activeTab !== "facilities") {
        fetchFacilityBarrelSummary();
      }
    }
  }, []);

  const handleSelectionModelChange = (newSelection: GridRowId[]) => {
    // Build a fast lookup of current row IDs
    const currentRowMap = new Map(tableData.map((row) => [row.id, row]));

    // Keep ONLY ids that still exist in current rows
    const validSelection = newSelection.filter((id) => currentRowMap.has(id));
    setSelectionModel(validSelection);

    // Build selected rows strictly from current data
    const updatedSelectedRows = validSelection.map((id) => currentRowMap.get(id)).filter(Boolean);
    setSelectedRows(updatedSelectedRows);

    // Reset derived state safely
    if (updatedSelectedRows.length === 0) {
      setSelectedLots([]);
      return;
    }

    const { dsp, mashBill, companyId } = updatedSelectedRows[0];
    const validLots = updatedSelectedRows
      .filter((row) => row.dsp === dsp && row.mashBill === mashBill && row.companyId === companyId).map((row) => row.lotNo);
    setSelectedLots(validLots);
  };

  const handleCreateListing = () => {
    if (selectedRows.length === 0 || selectedLots.length !== selectedRows.length
      || selectedRows.some((row) => row.unlistedQuantity === 0)) {
      const swalTitle = selectedRows.length === 0
        ? "Please Select Lot"
        : "Invalid Lot Selection";

      const swalText =
        selectedLots.length !== selectedRows.length
          ? "Please select lots from the same DSP, MashBill, and Company only."
          : selectedRows.some((row) => row.unlistedQuantity === 0)
            ? "The selected Container Lot(s) do not contain any unlisted container. Please select different lots with available unlisted container."
            : "";
      Swal.fire({
        html: `
      <style>
        .custom-swal .icon-container {
            background-color: #ffebee;
            border-radius: 50%;
            width: 105px;
            height: 105px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto 20px;
          }
          .custom-swal .icon-container i {
            color: #ff3e4e;
            font-size: 24px;
          }

          .custom-swal h2 {
            color: #333;
            font-family: Segoe UI;
            font-size: 28px;
            font-style: Semibold;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 22px;
            text-align: center;
            vertical-align: middle;
          }
          .custom-swal p {
            font-size: 14px;
            color: #666;
            margin-bottom: 28px;
          }
          .custom-swal .button-container {
            display: flex;
            justify-content: center;
            border-top:1px solid #d9d9d9;
            padding:16px;
          }
          .custom-swal button {
            border: none;
            padding: 10px 50px;
            border-radius: 30px;
            font-size: 14px;
            cursor: pointer;
          }
          .custom-swal .cancel-btn {
            background: #496673 !important;
            color: #FFFFFF !important;
            padding: 15px 16px !important;
            font-size:16px;
            border-radius: 100px !important;
            font-weight: 600 !important;
            border: 1px solid rgba(255, 255, 255, 0) !important;
            min-width: 190px;
            box-shadow: unset;
            outline: unset;
          }
          .custom-swal .delete-btn {
            background-color: #ec2323;
            color: white;
          }
            .swal-body{
            padding:30px 24px;
            display: flex;
            flex-direction: column;
            gap: 15px;
            justify-content: center;
            text-align: center;
            }
          
      </style>
        <div class="custom-swal">
          <div class="swal-body">
            <div class="icon-container" id="iconContainer">
            </div>

            <h2>${swalTitle}</h2>
            ${swalText ? `<p>${swalText}</p>` : ""}
          </div>
          <div class="button-container">
            <button class="cancel-btn" id="cancelBtn">Ok</button>
          </div>
        </div>`,
        showConfirmButton: false,
        showCancelButton: false,
        didOpen: () => {
          // Add the image after the popup has been rendered
          const iconContainer = Swal.getPopup()!.querySelector("#iconContainer");
          if (iconContainer) {
            const img = document.createElement("img");
            img.src = Info;
            img.width = 80;
            img.height = 80;
            iconContainer.appendChild(img);
          }
          const cancelBtn = Swal.getPopup()!.querySelector("#cancelBtn");
          cancelBtn?.addEventListener("click", () => {
            Swal.close();
          });
        },
        customClass: {
          popup: "create-listing-popup",
        },
        // icon: "warning",
        // title: selectedRows.length === 0 ? "Please Select Lot" : "Invalid Lot Selection",
        // text: selectedLots.length !== selectedRows.length
        //       ? "Please select lots from the same DSP, MashBill, and Company only."
        //       : selectedRows.some((row) => row.unlistedQuantity === 0)
        //           ? "The selected Barrel Lot(s) do not contain any unlisted container. Please select different lots with available unlisted container."
        //           : ""
      });
      return;
    }

    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    pushWithActiveTab(`${linkPrefix}/add-customer-service-request`, {
      data: "Sell Request",
      companyId: id === undefined ? selectedRows[0]?.companyId : id,
      lots: selectedLots
    });
  };

  const handleAddInventory = () => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    pushWithActiveTab(`${linkPrefix}/add-customer-service-request`, {
      data: "Bulk Inventory Upload",
      companyId: id === undefined ? selectedRows[0]?.companyId : id
    });
  };

  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString() || ""}>
        <span>{value?.toString() || "-"}</span>
      </Tooltip>
    );
  };

  // Returns true if the given filter field is controlled by the panel (should disable column input)
  const isColumnFilterDisabled = (field: string): boolean => {
    if (field === "companyName" && panelCompanies.length > 0) return true;
    if (field === "barrelOwnerName" && panelBarrelOwners.length > 0) return true;
    if (field === "facility" && panelFacilities.length > 0) return true;
    if (field === "lotNo" && panelLotNos.length > 0) return true;
    if (field === "producer" && panelProducers.length > 0) return true;
    if (field === "dsp" && panelDsps.length > 0) return true;
    if (field === "mashBill" && panelMashBills.length > 0) return true;
    return false;
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, field: keyof any) => {
    const value = event.target.value;

    // Only update state — API is triggered by Apply button via handlePanelApply
    // setFilter((prev: any) => ({
    //   ...prev,
    //   [field]: value,
    // }));
    filterRef.current = {
      ...(filterRef.current ?? filter),
      [field]: value,
    };
  };

  const triggerDelayedApi = (tempFilter: any) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      // Flush the latest filter into state once typing has stopped
      setFilter(tempFilter);
      filterRef.current = null;

      if (activeButtonRef.current === "product") {
        fetchProductListing(
          page,
          pageSize,
          tempFilter,
          "productName", sortDirection,
        );
      } else if (activeButtonRef.current === "facilities") {
        fetchFacilityListing(
          page,
          pageSize,
          tempFilter,
          "lotNo", sortDirection);
      } else {
        fetchContainerListing(
          page,
          pageSize,
          tempFilter,
          "lotNo", sortDirection,
        );
      }
    }, 1000); // Increased delay — waits for typing to stop before re-rendering and hitting API
  };

  const toggleSort = (field) => {
    const current = sortModel.find((s) => s.field === field);

    let newSort = "asc";

    if (current?.sort === "asc") {
      newSort = "desc";
    }

    setSortModel([{ field, sort: newSort }]);

    fetchContainerListing(page, pageSize, filter, field, newSort);
  };

  function TwoSortHeader({ title1, title2, field1, field2, sortModel, toggleSort }) {

    const getIcon = (field) => {
      const item = sortModel.find((s) => s.field === field);

      if (!item) return "";
      if (item.sort === "asc") {
        return (
          <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiDataGrid-sortIcon css-ptiqhd-MuiSvgIcon-root sorting-icon"
            focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowUpwardIcon">
            <path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"></path>
          </svg>
        );
      }
      if (item.sort === "desc") {
        return (
          <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiDataGrid-sortIcon css-ptiqhd-MuiSvgIcon-root sorting-icon"
            focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ArrowDownwardIcon">
            <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"></path>
          </svg>
        );
      }
    };

    return (
      <div className="d-flex flex-column h-100 justify-content-center list-data-wrapper gap-1">

        <div
          style={{ cursor: "pointer", fontWeight: 400, fontSize: "14px", lineHeight: "20px", color: "#6f6f6f" }}
          onClick={() => toggleSort(field1)}
        >
          {title1} {getIcon(field1)}
        </div>

        <div
          style={{ cursor: "pointer", fontWeight: 400, fontSize: "14px", lineHeight: "20px", color: "#6f6f6f" }}
          onClick={() => toggleSort(field2)}
        >
          {title2} {getIcon(field2)}
        </div>

      </div>
    );
  }

  function TwoLineCell({ value1, value2 }) {

    return (
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", paddingBlock: "8px", height: "100%" }}>
        <Tooltip arrow title={value1}><span style={{ fontSize: 14, color: "#333333", fontWeight: "400", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", lineHeight: "16px" }}>{value1}</span></Tooltip>
        <Tooltip arrow title={value2}>
          <span style={{ fontSize: 14, color: "#333333", fontWeight: "400", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", lineHeight: "16px" }}>
            {value2}
          </span>
        </Tooltip>
      </div>
    );
  }

  const containerColumns: GridColDef[] = [
    {
      field: "age",
      headerName: "Age",
      flex: 1,
      minWidth: 50,
      sortable: true,
      renderCell: (params) => {
        const currentDate = new Date();
        const fillDate = new Date(params.row.fillDate); // Use the fillDate field

        // Calculate the difference in years and months
        let years = currentDate.getFullYear() - fillDate.getFullYear();
        let months = currentDate.getMonth() - fillDate.getMonth();

        // Adjust for negative months (if current month is earlier than the fill month)
        if (months < 0) {
          years--;
          months += 12;
        }
        let final_years = years + " years";
        let final_months = months + " months";
        // Format the result as 'X years Y months'
        return (
          <TwoLineCell
          value1={final_years}
          value2={final_months}
          />
        );
      },
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.age || ''}
              // defaultValue={filter.age}
              onChange={(event) => handleFilterChange(event, "age")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "lotNoColumn",
      headerName: "Lot Id / Fill Date",
      flex: 1,
      minWidth: 210,
      sortable: false, // Disable default sorting to use custom header sorting
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: () => (
                <TwoSortHeader
                    title1="Lot Id(Fill Date)"
                    title2="Container Id"
                    field1="lotNo"
                    field2="barrelNumber"
                    sortModel={sortModel}
                    toggleSort={toggleSort}
                />
            ),

            renderCell: (params: any) => (
                <TwoLineCell
                    value1={`${params.row.lotNo} (${params.row.fillDate ?? "-"})`}
                    value2={params.row.barrelNumber}
                />
            )
    },
    {
      field: "producer",
      headerName: "Producer",
      flex: 1,
      sortable: true,
      minWidth: 100,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("producer") ? 0.5 : 1, cursor: isColumnFilterDisabled("producer") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.producer || ''}
              // defaultValue={filter.producer}
              disabled={isColumnFilterDisabled("producer")}
              title={isColumnFilterDisabled("producer") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "producer")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    // {
    //   field: "productName",
    //   headerName: "Title",
    //   flex: 1,
    //   sortable: true,
    //   minWidth: 200,
    //   renderCell: (params) => {
    //     const value = params.value;

    //     const displayValue = value
    //       ? value.replace(/^Unknown/i, "-")
    //       : "-";

    //     return <CellWithTooltip value={displayValue} />;
    //   },
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           defaultValue={filter.title || ''}
    //           // defaultValue={filter.title}
    //           onChange={(event) => handleFilterChange(event, "title")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    {
      field: "barrelOwnerName",
      headerName: "Owner Name",
      flex: 1,
      sortable: true,
      minWidth: 100,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("barrelOwnerName") ? 0.5 : 1, cursor: isColumnFilterDisabled("barrelOwnerName") ? "not-allowed" : undefined }}
              placeholder="Search"
              value={filter.barrelOwnerName || ''}
              disabled={isColumnFilterDisabled("barrelOwnerName")}
              title={isColumnFilterDisabled("barrelOwnerName") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "barrelOwnerName")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    ...(CommonService.isAdmin()
      ? [
        {
          field: "companyName",
          headerName: "Account Owner Name",
          flex: 1,
          sortable: true,
          minWidth: 110,
          //valueGetter: (value: any, row: any) => `${row.ecommUser.firstName || ''} ${row.ecommUser.lastName || ''}`,
          headerClassName: "table-header border-0 my-2 h-100",
          renderHeader: (params) => (
            <div>
              <Typography
                variant="body2"
                sx={{ color: "#6F6F6F", fontSize: "14px" }}
              >
                {params.colDef.headerName}
              </Typography>
              {/* <div className="position-relative" style={{ width: "100px" }}>
                <input
                  type="text"
                  className="form-control border mt-1"
                  style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("companyName") ? 0.5 : 1, cursor: isColumnFilterDisabled("companyName") ? "not-allowed" : undefined }}
                  placeholder="Search"
                  defaultValue={filter.companyName || ""}
                  // defaultValue={filter.ownerName}
                  disabled={isColumnFilterDisabled("companyName")}
                  title={isColumnFilterDisabled("companyName") ? "Controlled by Filter Panel" : undefined}
                  onChange={(event) => handleFilterChange(event, "companyName")}
                  onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                />
                <SearchIcon
                  sx={{
                    color: "#6F6F6F",
                    position: "absolute",
                    top: "50%",
                    left: "8px",
                    transform: "translateY(-50%)",
                  }}
                />
              </div> */}
            </div>
          ),
        },
      ]
      : []),
    {
      field: "containerHealth",
      headerName: "Container Health",
      flex: 1,
      minWidth: 100,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.rackhouse || ''}
              // defaultValue={filter.rackhouse}
              onChange={(event) => handleFilterChange(event, "rackhouse")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "rackhouse",
      headerName: "Warehouse",
      flex: 1,
      minWidth: 100,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.rackhouse || ''}
              // defaultValue={filter.rackhouse}
              onChange={(event) => handleFilterChange(event, "rackhouse")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
      renderCell: (params) => <CellWithTooltip value={params.value} />,
    },
    {
      field: "mashBill",
      headerName: "Mash Bill",
      flex: 1,
      minWidth: 100,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("mashBill") ? 0.5 : 1, cursor: isColumnFilterDisabled("mashBill") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.mashBill || ''}
              // defaultValue={filter.mashBill}
              disabled={isColumnFilterDisabled("mashBill")}
              title={isColumnFilterDisabled("mashBill") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "mashBill")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "proofColumns",
      headerName: "Proof / Proof Gallon",
      flex: 1,
      minWidth: 50,
      sortable: false, // Disable default sorting to use custom header sorting
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: () => (
                <TwoSortHeader
                    title1="Proof"
                    title2="PG"
                    field1="proof"
                    field2="proofGallons"
                    sortModel={sortModel}
                    toggleSort={toggleSort}
                />
            ),

            renderCell: (params: any) => (
                <TwoLineCell
                    value1={params.row.proof}
                    value2={params.row.proofGallons}
                />
            )
    },
    // {
    //   field: "proof",
    //   headerName: "Proof",
    //   flex: 1,
    //   sortable: true,
    //   minWidth: 100,
    //   renderCell: (params) => <CellWithTooltip value={params.value === 0 ? "-" : CommonService.formatToSingleDecimal(params.value)} />,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="number"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           defaultValue={filter.proof || ''}
    //           // defaultValue={filter.title}
    //           onChange={(event) => handleFilterChange(event, "proof")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    // {
    //   field: "containerCooperage",
    //   headerName: "Container Condition",
    //   flex: 1,
    //   minWidth: 140,
    //   sortable: true,
    //   renderCell: (params) => {
    //     const value = params.value || "";
    //     // const isBarrel = params.row.containerType === "BARREL";
    //     if (!value) {
    //       return <CellWithTooltip value="-" />;
    //     }
    //     const isNew = value.includes("NEW");
    //     const isReused = value.includes("REUSED");
    //     const tooltipText = isNew && isReused ? "New and Reused" : isNew ? "New" : isReused ? "Reused" : "-";
    //     return (
    //       <>
    //         {isReused && (
    //           <span className="cooperage-text me-1">R</span>
    //         )}
    //         {isNew && (
    //           <span className="cooperage-text new-text me-1">N</span>
    //         )}
    //         <CellWithTooltip value={tooltipText} />
    //       </>
    //     );
    //   },
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           defaultValue={filter.containerCooperage || ''}
    //           // defaultValue={filter.facility}
    //           onChange={(event) => handleFilterChange(event, "containerCooperage")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    // {
    //   field: "dsp",
    //   headerName: "DSP",
    //   flex: 1,
    //   sortable: true,
    //   minWidth: 100,
    //   renderCell: (params) => <CellWithTooltip value={params.value} />,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("dsp") ? 0.5 : 1, cursor: isColumnFilterDisabled("dsp") ? "not-allowed" : undefined }}
    //           placeholder="Search"
    //           defaultValue={filter.dsp || ''}
    //           // defaultValue={filter.dsp}
    //           disabled={isColumnFilterDisabled("dsp")}
    //           title={isColumnFilterDisabled("dsp") ? "Controlled by Filter Panel" : undefined}
    //           onChange={(event) => handleFilterChange(event, "dsp")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    // {
    //   field: "fillDate",
    //   headerName: "Fill Date",
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   flex: 1,
    //   sortable: true,
    //   minWidth: 120,
    //   renderCell: (params: any) => <CellWithTooltip value={params.value} />,
    //   valueGetter: (value: any, row: any) => {
    //     const dateTimeString = row.fillDate ? row.fillDate : null;
    //     if (dateTimeString) {
    //       return dateTimeString;
    //     }
    //   },
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div style={{ width: "120px" }}>
    //         <input
    //           type="date"
    //           className="form-control border mt-1"
    //           style={{ boxShadow: "none" }}
    //           id="birthdate"
    //           name="birthdate"
    //           placeholder="MM/DD/YYYY"
    //           defaultValue={filter.fillDate || ''}
    //           // defaultValue={filter.fillDate}
    //           onChange={(event) => handleFilterChange(event, "fillDate")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    // {
    //   field: "isAvailableForSell",
    //   headerName: "Is Listed",
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   cellClassName: "status-badge",
    //   flex: 1,
    //   minWidth: 100,
    //   sortable: true,
    //   valueGetter: (value: any, row: any) =>
    //     row.isAvailableForSell ? "Yes" : "No",
    //   renderHeader: (params) => (
    //     <>
    //       <div>
    //         <Typography
    //           variant="body2"
    //           sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //         >
    //           {params.colDef.headerName}
    //         </Typography>
    //         {/* <div className="position-relative" style={{ width: "90px" }}>
    //           <Form.Select
    //             style={{
    //               cursor: "pointer",
    //               borderBottomColor: "#D1D1D1",
    //               marginTop: "4px",
    //             }}
    //             defaultValue={filter.isAvailableForSell || ''}
    //             className="form-control mb-1"
    //             onChange={(event) =>
    //               handleFilterChange(event, "isAvailableForSell")
    //             }
    //             onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //           >
    //             <option value="">Select Value</option>
    //             <option value="true">Yes</option>
    //             <option value="false">No</option>
    //           </Form.Select>
    //         </div> */}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   field: "barrelCost",
    //   headerName: "Container Cost",
    //   flex: 1,
    //   minWidth: 150,
    //   sortable: true,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           defaultValue={filter.barrelCost || ''}
    //           // defaultValue={filter.price}
    //           onChange={(event) => handleFilterChange(event, "barrelCost")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    //   renderCell: (params: any) => {
    //     const row = params.row;

    //     if (!CommonService.isAdmin() && row.barrelOwnerName !== row.companyName && CommonService.getCompanyId() === row.companyId) {
    //       return <span className="text-muted">-</span>;
    //     }

    //     return (
    //       <CurrencyFormatter
    //         amount={params.row.barrelCost}
    //         locale="en-US"
    //         currency="USD"
    //       />
    //     );
    //   },
    // },
    // {
    //   field: "sellCost",
    //   headerName: "Sell Cost",
    //   flex: 1,
    //   minWidth: 120,
    //   sortable: true,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           defaultValue={filter.sellCost || ''}
    //           // defaultValue={filter.price}
    //           onChange={(event) => handleFilterChange(event, "sellCost")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    //   renderCell: (params: any) => {
    //     const row = params.row;

    //     if (!CommonService.isAdmin() && row.barrelOwnerName !== row.companyName && CommonService.getCompanyId() === row.companyId) {
    //       return <span className="text-muted">-</span>;
    //     }

    //     return (
    //       <CurrencyFormatter
    //         amount={params.row.sellCost}
    //         locale="en-US"
    //         currency="USD"
    //       />
    //     );
    //   },
    // },
    // {
    //   field: "isFilled",
    //   headerName: "Is Filled",
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   cellClassName: "status-badge",
    //   flex: 1,
    //   minWidth: 100,
    //   sortable: true,
    //   valueGetter: (value: any, row: any) => row.isFilled ? "Yes" : "No",
    //   renderHeader: (params) => (
    //     <>
    //       <div>
    //         <Typography
    //           variant="body2"
    //           sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //         >
    //           {params.colDef.headerName}
    //         </Typography>
    //         {/* <div className="position-relative" style={{ width: "100px" }}>
    //           <Form.Select
    //             style={{
    //               cursor: "pointer",
    //               borderBottomColor: "#D1D1D1",
    //               marginTop: "4px",
    //             }}
    //             defaultValue={filter.isFilled || ''}
    //             className="form-control mb-1"
    //             onChange={(event) =>
    //               handleFilterChange(event, "isFilled")
    //             }
    //             onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //           >
    //             <option value="">Select Value</option>
    //             <option value="true">Yes</option>
    //             <option value="false">No</option>
    //           </Form.Select>
    //         </div> */}
    //       </div>
    //     </>
    //   ),
    // },
    // {
    //   field: "facility",
    //   headerName: "Facility",
    //   flex: 1,
    //   minWidth: 170,
    //   sortable: true,
    //   renderCell: (params) => <CellWithTooltip value={params.row.facilityName} />,
    //   //valueGetter: (value: any, row: any) => `${row.ecommUser.firstName || ''} ${row.ecommUser.lastName || ''}`,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("facility") ? 0.5 : 1, cursor: isColumnFilterDisabled("facility") ? "not-allowed" : undefined }}
    //           placeholder="Search"
    //           defaultValue={filter.facility || ''}
    //           // defaultValue={filter.facility}
    //           disabled={isColumnFilterDisabled("facility")}
    //           title={isColumnFilterDisabled("facility") ? "Controlled by Filter Panel" : undefined}
    //           onChange={(event) => handleFilterChange(event, "facility")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    // {
    //   field: "description",
    //   headerName: "Container Description",
    //   flex: 1,
    //   minWidth: 170,
    //   sortable: true,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "170px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           defaultValue={filter.description || ''}
    //           // defaultValue={filter.description}
    //           onChange={(event) => handleFilterChange(event, "description")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    {
      field: "createdDate",
      headerName: "Created On",
      headerClassName: "table-header border-0 my-2 h-100",
      flex: 1,
      sortable: true,
      minWidth: 130,
      renderCell: (params: any) => {
        const dateTimeString = params.row.createdDate;

        if (!dateTimeString) return null;

        const formattedDateTime = CommonService.formatDateTime(dateTimeString);

        const parts = formattedDateTime.split(",");
        const date = `${parts[0]?.trim()}, ${parts[1]?.trim()}`;
        const time = parts[2]?.trim();

        return (
          <TwoLineCell
          value1={date}
          value2={time}
          />
        );
      },
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <input
            type="date"
            className="form-control border mt-1"
            style={{ boxShadow: "none" }}
            id="createdDate"
            name="createdDate"
            placeholder="MM/DD/YYYY"
            defaultValue={filter.createdDate}
            onChange={(event) => handleFilterChange(event, "createdDate")}
            onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
          /> */}
        </div>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      width: 70,
      headerClassName: "table-header border-0 my-2 h-100",
      cellClassName: "action-cell",
      renderCell: (params: any) => (
        <div onClick={(e) => e.stopPropagation()}>

          {/* {CommonService.isAdmin() && !params?.row?.khBarrelId && 
            <Tooltip title="Edit" arrow>
              <IconButton onClick={() => handleEditBarrelClick(params?.row?.id)}
                aria-label="edit"
                size="small">
                <img
                  src={EditIcon}
                  className="cursor-pointer"
                  alt="EditIcon"
                />
              </IconButton>
            </Tooltip>}
            <Tooltip title="Proof History" arrow>
              <IconButton onClick={() => handleProofHistoryClick(params?.row?.id, params?.row?.barrelNumber)}
                aria-label="edit"
                size="small">
                <img
                  src={ProofIcon}
                  className="cursor-pointer"
                  alt="ProofIcon"
                />
              </IconButton>
            </Tooltip>
            <Tooltip title="Valuation History" arrow>
              <IconButton onClick={() => handleValuationHistoryClick(params?.row?.id, params?.row?.barrelNumber)}
                aria-label="edit"
                size="small">
                <img
                  src={ValuationHistory}
                  className="cursor-pointer"
                  alt="ValuationHistory"
                  height={"24px"}
                />
              </IconButton>
            </Tooltip> */}
          <div className="dropdown action-dropdown" ref={dropdownRef}>
            <button
              className="btn dropdown-toggle"
              type="button"
              onClick={(e) => {
                e.stopPropagation(); // important inside MUI DataGrid
                toggleDropdown(params.row.id);
              }}
              aria-expanded={openRowId === params.row.id}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.9987 6.66146C10.9154 6.66146 11.6654 5.91146 11.6654 4.99479C11.6654 4.07812 10.9154 3.32812 9.9987 3.32812C9.08203 3.32812 8.33203 4.07812 8.33203 4.99479C8.33203 5.91146 9.08203 6.66146 9.9987 6.66146ZM9.9987 8.32812C9.08203 8.32812 8.33203 9.07812 8.33203 9.99479C8.33203 10.9115 9.08203 11.6615 9.9987 11.6615C10.9154 11.6615 11.6654 10.9115 11.6654 9.99479C11.6654 9.07812 10.9154 8.32812 9.9987 8.32812ZM9.9987 13.3281C9.08203 13.3281 8.33203 14.0781 8.33203 14.9948C8.33203 15.9115 9.08203 16.6615 9.9987 16.6615C10.9154 16.6615 11.6654 15.9115 11.6654 14.9948C11.6654 14.0781 10.9154 13.3281 9.9987 13.3281Z" fill="black" fill-opacity="0.54" />
              </svg>

            </button>
            <ul className={`dropdown-menu ${openRowId === params.row.id ? "show" : ""}`} onMouseDown={(e) => e.stopPropagation()}>
              {CommonService.isAdmin() 
              && <li>
                {/* <a
                  className="dropdown-item d-flex align-items-center gap-2"
                  aria-current="page"
                  onClick={() => handleContainerEditBarrelClick(params?.row?.id, params?.row?.barrelNumber, params?.row?.lotNo)}
                  role="button"
                  aria-expanded="false"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.4569 7.7975C15.435 7.74813 14.9056 6.57375 13.7287 5.39687C12.1606 3.82875 10.18 3 7.99999 3C5.81999 3 3.83937 3.82875 2.27124 5.39687C1.09437 6.57375 0.562494 7.75 0.543119 7.7975C0.51469 7.86144 0.5 7.93064 0.5 8.00062C0.5 8.0706 0.51469 8.1398 0.543119 8.20375C0.564994 8.25312 1.09437 9.42688 2.27124 10.6038C3.83937 12.1713 5.81999 13 7.99999 13C10.18 13 12.1606 12.1713 13.7287 10.6038C14.9056 9.42688 15.435 8.25312 15.4569 8.20375C15.4853 8.1398 15.5 8.0706 15.5 8.00062C15.5 7.93064 15.4853 7.86144 15.4569 7.7975ZM7.99999 12C6.07624 12 4.39562 11.3006 3.00437 9.92188C2.43352 9.35418 1.94786 8.70685 1.56249 8C1.94776 7.29309 2.43343 6.64574 3.00437 6.07812C4.39562 4.69938 6.07624 4 7.99999 4C9.92374 4 11.6044 4.69938 12.9956 6.07812C13.5676 6.6456 14.0543 7.29295 14.4406 8C13.99 8.84125 12.0269 12 7.99999 12ZM7.99999 5C7.40665 5 6.82663 5.17595 6.33328 5.50559C5.83994 5.83524 5.45542 6.30377 5.22836 6.85195C5.00129 7.40013 4.94188 8.00333 5.05764 8.58527C5.17339 9.16721 5.45912 9.70176 5.87867 10.1213C6.29823 10.5409 6.83278 10.8266 7.41472 10.9424C7.99667 11.0581 8.59987 10.9987 9.14804 10.7716C9.69622 10.5446 10.1648 10.1601 10.4944 9.66671C10.824 9.17336 11 8.59334 11 8C10.9992 7.2046 10.6828 6.44202 10.1204 5.87959C9.55797 5.31716 8.79539 5.00083 7.99999 5ZM7.99999 10C7.60443 10 7.21775 9.8827 6.88885 9.66294C6.55996 9.44318 6.30361 9.13082 6.15224 8.76537C6.00086 8.39991 5.96125 7.99778 6.03842 7.60982C6.11559 7.22186 6.30608 6.86549 6.58578 6.58579C6.86549 6.30608 7.22185 6.1156 7.60981 6.03843C7.99778 5.96126 8.39991 6.00087 8.76536 6.15224C9.13081 6.30362 9.44317 6.55996 9.66293 6.88886C9.8827 7.21776 9.99999 7.60444 9.99999 8C9.99999 8.53043 9.78928 9.03914 9.41421 9.41421C9.03913 9.78929 8.53043 10 7.99999 10Z" fill="black" />
                  </svg>

                  View Container Details
                </a> */}
              </li>}
              {CommonService.isAdmin() && !params?.row?.khBarrelId && <li>
                <a
                  className="dropdown-item d-flex align-items-center gap-2"
                  aria-current="page"
                  onClick={() => handleEditBarrelClick(params?.row?.id)}
                  role="button"
                  aria-expanded="false"
                >
                  <img
                    src={EditIcon}
                    className="cursor-pointer"
                    alt="EditIcon"
                    height={16}
                  />
                  Edit Container Details
                </a>
              </li>}
              <li>
                <a
                  className="dropdown-item d-flex align-items-center"
                  aria-current="page"
                  onClick={() => handleProofHistoryClick(params?.row?.id, params?.row?.barrelNumber)}
                  role="button"
                  aria-expanded="false"
                >
                  <img
                    src={ProofIcon}
                    className="cursor-pointer"
                    alt="ProofIcon"
                    height={14}
                    width={16}
                  />
                  View Proofing History
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => handleValuationHistoryClick(params?.row?.id, params?.row?.barrelNumber)}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4983 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5ZM10.5 9.25C10.5 9.71413 10.3156 10.1592 9.98744 10.4874C9.65925 10.8156 9.21413 11 8.75 11H8.5V11.5C8.5 11.6326 8.44732 11.7598 8.35356 11.8536C8.25979 11.9473 8.13261 12 8 12C7.86739 12 7.74022 11.9473 7.64645 11.8536C7.55268 11.7598 7.5 11.6326 7.5 11.5V11H6.5C6.36739 11 6.24022 10.9473 6.14645 10.8536C6.05268 10.7598 6 10.6326 6 10.5C6 10.3674 6.05268 10.2402 6.14645 10.1464C6.24022 10.0527 6.36739 10 6.5 10H8.75C8.94892 10 9.13968 9.92098 9.28033 9.78033C9.42098 9.63968 9.5 9.44891 9.5 9.25C9.5 9.05109 9.42098 8.86032 9.28033 8.71967C9.13968 8.57902 8.94892 8.5 8.75 8.5H7.25C6.78587 8.5 6.34075 8.31563 6.01257 7.98744C5.68438 7.65925 5.5 7.21413 5.5 6.75C5.5 6.28587 5.68438 5.84075 6.01257 5.51256C6.34075 5.18437 6.78587 5 7.25 5H7.5V4.5C7.5 4.36739 7.55268 4.24021 7.64645 4.14645C7.74022 4.05268 7.86739 4 8 4C8.13261 4 8.25979 4.05268 8.35356 4.14645C8.44732 4.24021 8.5 4.36739 8.5 4.5V5H9.5C9.63261 5 9.75979 5.05268 9.85356 5.14645C9.94732 5.24021 10 5.36739 10 5.5C10 5.63261 9.94732 5.75979 9.85356 5.85355C9.75979 5.94732 9.63261 6 9.5 6H7.25C7.05109 6 6.86032 6.07902 6.71967 6.21967C6.57902 6.36032 6.5 6.55109 6.5 6.75C6.5 6.94891 6.57902 7.13968 6.71967 7.28033C6.86032 7.42098 7.05109 7.5 7.25 7.5H8.75C9.21413 7.5 9.65925 7.68437 9.98744 8.01256C10.3156 8.34075 10.5 8.78587 10.5 9.25Z" fill="black" />
                  </svg>

                  View Valuation History
                </a>
              </li>
              {/* <li>
                  <a
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => route("/master/tasting-history")}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.835 6.47937L11.4744 1.85875C11.4439 1.75523 11.3807 1.66435 11.2943 1.59969C11.2079 1.53503 11.1029 1.50006 10.995 1.5H5.00876C4.90085 1.50006 4.79584 1.53503 4.70944 1.59969C4.62304 1.66435 4.55988 1.75523 4.52939 1.85875L3.16876 6.47937C2.95529 7.1876 2.94412 7.9414 3.13651 8.65564C3.3289 9.36987 3.71719 10.0161 4.25751 10.5212C5.14633 11.3548 6.28834 11.8671 7.50189 11.9769V14.5H5.50189C5.36928 14.5 5.2421 14.5527 5.14834 14.6464C5.05457 14.7402 5.00189 14.8674 5.00189 15C5.00189 15.1326 5.05457 15.2598 5.14834 15.3536C5.2421 15.4473 5.36928 15.5 5.50189 15.5H10.5019C10.6345 15.5 10.7617 15.4473 10.8554 15.3536C10.9492 15.2598 11.0019 15.1326 11.0019 15C11.0019 14.8674 10.9492 14.7402 10.8554 14.6464C10.7617 14.5527 10.6345 14.5 10.5019 14.5H8.50189V11.9769C9.71542 11.8671 10.8574 11.3547 11.7463 10.5212C12.2866 10.0161 12.6749 9.36987 12.8673 8.65564C13.0597 7.9414 13.0485 7.1876 12.835 6.47937ZM5.38251 2.5H10.6213L11.8769 6.76188C11.8825 6.78063 11.8875 6.79937 11.8925 6.81812C10.5538 7.29812 9.04626 6.71812 8.22814 6.30375C6.65376 5.50688 5.40376 5.40563 4.48189 5.55813L5.38251 2.5ZM11.0644 9.79062C10.2341 10.568 9.1393 11.0006 8.00189 11.0006C6.86448 11.0006 5.76964 10.568 4.93939 9.79062C4.53506 9.41172 4.24472 8.92733 4.10115 8.39214C3.95758 7.85694 3.96649 7.29227 4.12689 6.76188L4.15501 6.66687C4.90501 6.41313 6.09689 6.34562 7.77564 7.19625C8.47251 7.54938 9.59814 7.99937 10.8025 7.99937C11.205 8.00134 11.6059 7.94663 11.9931 7.83687C11.9421 8.58223 11.6102 9.28048 11.0644 9.79062Z" fill="black"/>
                    </svg>
                    View Tasting Notes History
                  </a>
                </li> */}
            </ul>
          </div>
        </div>
      ),
    },
    {field: "lotNo"},
    {field: "barrelNumber"},
    {field: "proof"},
    {field: "proofGallons"},
  ].filter(Boolean) as GridColDef[];

  const containerLotColumns: GridColDef[] = [
    {
      field: "age",
      headerName: "Age",
      flex: 1,
      minWidth: 50,
      sortable: true,
      renderCell: (params) => {
        const currentDate = new Date();
        const fillDate = new Date(params.row.fillDate); // Use the fillDate field

        // Calculate the difference in years and months
        let years = currentDate.getFullYear() - fillDate.getFullYear();
        let months = currentDate.getMonth() - fillDate.getMonth();

        // Adjust for negative months (if current month is earlier than the fill month)
        if (months < 0) {
          years--;
          months += 12;
        }
        let final_years = years + " years";
        let final_months = months + " months";
        // Format the result as 'X years Y months'
        return (
          <TwoLineCell
          value1={final_years}
          value2={final_months}
          />
        );
      },
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.age || ''}
              // defaultValue={filter.age}
              onChange={(event) => handleFilterChange(event, "age")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "lotNoColumn",
      headerName: "Lot ID / Fill Date",
      flex: 1,
      minWidth: 130,
      sortable: false,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: () => (
                <TwoSortHeader
                    title1="Lot Id"
                    title2="Fill Date"
                    field1="lotNo"
                    field2="fillDate"
                    sortModel={sortModel}
                    toggleSort={toggleSort}
                />
            ),

            renderCell: (params: any) => (
                <TwoLineCell
                    value1={params.row.lotNo}
                    value2={params.row.fillDate}
                />
            )
    },
    {
      field: "producer",
      headerName: "Producer",
      flex: 1,
      sortable: true,
      minWidth: 100,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("producer") ? 0.5 : 1, cursor: isColumnFilterDisabled("producer") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.producer || ''}
              // defaultValue={filter.producer}
              disabled={isColumnFilterDisabled("producer")}
              title={isColumnFilterDisabled("producer") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "producer")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },  
    {
      field: "ttbType",
      headerName: "TTB Type",
      flex: 1,
      sortable: true,
      minWidth: 100,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
        </div>
      ),
    },
    {
      field: "mashBill",
      headerName: "Mash Bill",
      flex: 1,
      minWidth: 100,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("mashBill") ? 0.5 : 1, cursor: isColumnFilterDisabled("mashBill") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.mashBill || ''}
              // defaultValue={filter.mashBill}
              disabled={isColumnFilterDisabled("mashBill")}
              title={isColumnFilterDisabled("mashBill") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "mashBill")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "facility",
      headerName: "Facility",
      flex: 1,
      minWidth: 100,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.row.facilityName} />,
      //valueGetter: (value: any, row: any) => `${row.ecommUser.firstName || ''} ${row.ecommUser.lastName || ''}`,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("facility") ? 0.5 : 1, cursor: isColumnFilterDisabled("facility") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.facility || ''}
              // defaultValue={filter.facility}
              disabled={isColumnFilterDisabled("facility")}
              title={isColumnFilterDisabled("facility") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "facility")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    ...(CommonService.isAdmin()
      ? [
        {
          field: "companyName",
          headerName: "Account Owner Name",
          flex: 1,
          sortable: true,
          minWidth: 130,
          //valueGetter: (value: any, row: any) => `${row.ecommUser.firstName || ''} ${row.ecommUser.lastName || ''}`,
          headerClassName: "table-header border-0 my-2 h-100",
          renderHeader: (params) => (
            <div>
              <Typography
                variant="body2"
                sx={{ color: "#6F6F6F", fontSize: "14px" }}
              >
                {params.colDef.headerName}
              </Typography>
              {/* <div className="position-relative" style={{ width: "120px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("companyName") ? 0.5 : 1, cursor: isColumnFilterDisabled("companyName") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.companyName || ""}
              // defaultValue={filter.ownerName}
              disabled={isColumnFilterDisabled("companyName")}
              title={isColumnFilterDisabled("companyName") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "companyName")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
            </div>
          ),
        },
      ]
      : []),
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 1,
      minWidth: 100,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      valueGetter: (value: any, row: any) => row.quantity ?? 0,
      renderHeader: (params) => (
        <div>
          <Typography variant="body2" sx={{ color: "#6F6F6F", fontSize: "14px" }}>
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.quantity || ''}
              min={0}
              onKeyDown={(e) => {
                if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                  e.preventDefault();
                }
              }}
              onChange={(event) => {
                if (Number(event.target.value) < 0) return;
                handleFilterChange(event, "quantity");
              }}
              onClick={(event) => event.stopPropagation()}
            />
            <SearchIcon sx={{ color: "#6F6F6F", position: "absolute", top: "50%", left: "8px", transform: "translateY(-50%)" }} />
          </div> */}
        </div>
      ),
      renderCell: (params) => (
        <CellWithTooltip value={params.row.quantity ?? 0} />
      ),
    },
    // {
    //   field: "productName",
    //   headerName: "Title",
    //   flex: 1,
    //   sortable: true,
    //   minWidth: 240,
    //   renderCell: (params) => {
    //     const value = params.value;

    //     const displayValue = value
    //       ? value.replace(/^Unknown/i, "-")
    //       : "-";

    //     return <CellWithTooltip value={displayValue} />;
    //   },
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "140px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           defaultValue={filter.title || ''}
    //           // defaultValue={filter.title}
    //           onChange={(event) => handleFilterChange(event, "title")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    // {
    //   field: "dsp",
    //   headerName: "DSP",
    //   flex: 1,
    //   sortable: true,
    //   minWidth: 150,
    //   renderCell: (params) => <CellWithTooltip value={params.value} />,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("dsp") ? 0.5 : 1, cursor: isColumnFilterDisabled("dsp") ? "not-allowed" : undefined }}
    //           placeholder="Search"
    //           defaultValue={filter.dsp || ''}
    //           // defaultValue={filter.dsp}
    //           disabled={isColumnFilterDisabled("dsp")}
    //           title={isColumnFilterDisabled("dsp") ? "Controlled by Filter Panel" : undefined}
    //           onChange={(event) => handleFilterChange(event, "dsp")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    // {
    //   field: "fillDate",
    //   headerName: "Fill Date",
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   flex: 1,
    //   sortable: true,
    //   minWidth: 150,
    //   renderCell: (params: any) => <CellWithTooltip value={params.value} />,
    //   valueGetter: (value: any, row: any) => {
    //     const dateTimeString = row.fillDate ? row.fillDate : null;
    //     if (dateTimeString) {
    //       return dateTimeString;
    //     }
    //   },
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div style={{ width: "120px" }}>
    //         <input
    //           type="date"
    //           className="form-control border mt-1"
    //           style={{ boxShadow: "none" }}
    //           id="birthdate"
    //           name="birthdate"
    //           placeholder="MM/DD/YYYY"
    //           defaultValue={filter.fillDate || ''}
    //           // defaultValue={filter.fillDate}
    //           onChange={(event) => handleFilterChange(event, "fillDate")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //       </div> */}
    //     </div>
    //   ),
    // },
    {
      field: "listedQuantity",
      headerName: "Listed Quantity",
      flex: 1,
      minWidth: 100,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      cellClassName: "info-dropdown",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.lotQuantity || ''}
              onChange={(event) => handleFilterChange(event, "lotQuantity")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
      renderCell: (params) => {
        return (
          <div>
            {params.row.listedQuantity +
              params.row.reservedQuantity
            }
            <Dropdown drop="end" className="d-inline-block">
              <Dropdown.Toggle
                variant="basic"
                id="dropdown-basic"
                className="p-0"
                style={{ marginTop: "-5px" }}
              >
                <InfoIcon sx={{ color: "#6F6F6F" }} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#/action-1">
                  Available Quantity{" "}
                  {params.row.listedQuantity}
                </Dropdown.Item>
                <Dropdown.Item href="#/action-2">
                  Reserved Quantity {params.row.reservedQuantity ?? ""}
                </Dropdown.Item>
                <Dropdown.Item href="#/action-3">
                  Sold Quantity {params.row.soldQuantity ?? ""}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        );
      },
    },
    {
      field: "isNotAvailableForSell",
      headerName: "Unlisted Quantity",
      flex: 1,
      minWidth: 100,
      headerClassName: "table-header border-0 my-2 h-100",
      valueGetter: (value: any, row: any) => row.unlistedQuantity,
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.initialQuantity || ''}
              // defaultValue={filter.initialQuantity} // For column-wise filter use initialQuantity to represent the quantity that is not available for sale
              onChange={(event) =>
                handleFilterChange(event, "initialQuantity")
              }
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    // {
    //   field: "rackhouse",
    //   headerName: "Warehouse",
    //   flex: 1,
    //   minWidth: 170,
    //   sortable: true,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       {/* <div className="position-relative" style={{ width: "100px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           defaultValue={filter.rackhouse || ''}
    //           // defaultValue={filter.rackhouse}
    //           onChange={(event) => handleFilterChange(event, "rackhouse")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div>*/}
    //     </div>
    //   ),
    //   renderCell: (params) => <CellWithTooltip value={params.value} />,
    // },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      width: 70,
      headerClassName: "table-header border-0 my-2 h-100",
      cellClassName: "action-cell",
      renderCell: (params: any) => (
        <div onClick={(e) => e.stopPropagation()}>
          {(CommonService.isAdmin()) && !params?.row?.khBarrelId && (
            <Tooltip title="Edit" arrow>
              <IconButton onClick={() => handleEditLotLevelClick(params?.row?.id)}
                aria-label="edit"
                size="small">
                <img
                  src={EditIcon}
                  className="cursor-pointer"
                  alt="EditIcon"
                />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ),
    },
    {field: "lotNo"},
    {field: "fillDate"}
  ].filter(Boolean) as GridColDef[];

  const productColumns: GridColDef[] = [
    {
      field: "productName",
      headerName: "Product Name",
      flex: 1,
      minWidth: 170,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderCell: (params) => {
        // const value = params.value;

        // const displayValue = value
        //   ? value.replace(/^Unknown/i, "-")
        //   : "-";

        return <CellWithTooltip value={params.value} />;
      },
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.productName || ''}
              // defaultValue={filter.productName}
              onChange={(event) => handleFilterChange(event, "productName")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    ...(CommonService.isAdmin()
      ? [
        {
          field: "companyName",
          headerName: "Account Owner Name",
          flex: 1,
          minWidth: 170,
          sortable: true,
          //valueGetter: (value: any, row: any) => `${row.ecommUser.firstName || ''} ${row.ecommUser.lastName || ''}`,
          headerClassName: "table-header border-0 my-2 h-100",
          renderHeader: (params) => (
            <div>
              <Typography
                variant="body2"
                sx={{ color: "#6F6F6F", fontSize: "14px" }}
              >
                {params.colDef.headerName}
              </Typography>
              {/* <div className="position-relative" style={{ width: "100px" }}>
                <input
                  type="text"
                  className="form-control border mt-1"
                  style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("companyName") ? 0.5 : 1, cursor: isColumnFilterDisabled("companyName") ? "not-allowed" : undefined }}
                  placeholder="Search"
                  defaultValue={filter.companyName || ''}
                  // defaultValue={filter.ownerName}
                  disabled={isColumnFilterDisabled("companyName")}
                  title={isColumnFilterDisabled("companyName") ? "Controlled by Filter Panel" : undefined}
                  onChange={(event) => handleFilterChange(event, "companyName")}
                  onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                />
                <SearchIcon
                  sx={{
                    color: "#6F6F6F",
                    position: "absolute",
                    top: "50%",
                    left: "8px",
                    transform: "translateY(-50%)",
                  }}
                />
              </div> */}
            </div>
          ),
        },
      ]
      : []),
    {
      field: "mashBill",
      headerName: "Mash Bill",
      flex: 1,
      minWidth: 150,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("mashBill") ? 0.5 : 1, cursor: isColumnFilterDisabled("mashBill") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.mashBill || ''}
              // defaultValue={filter.mashBill}
              disabled={isColumnFilterDisabled("mashBill")}
              title={isColumnFilterDisabled("mashBill") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "mashBill")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "dsp",
      headerName: "DSP",
      flex: 1,
      minWidth: 150,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("dsp") ? 0.5 : 1, cursor: isColumnFilterDisabled("dsp") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.dsp || ''}
              // defaultValue={filter.dsp}
              disabled={isColumnFilterDisabled("dsp")}
              title={isColumnFilterDisabled("dsp") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "dsp")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    // {
    //   field: "batchName",
    //   headerName: "Batch Name",
    //   flex: 1,
    //   minWidth: 200,
    //   sortable: true,
    //   renderCell: (params) => <CellWithTooltip value={params.value} />,
    //   headerClassName: "table-header border-0 my-2 h-100",
    //   renderHeader: (params) => (
    //     <div>
    //       <Typography
    //         variant="body2"
    //         sx={{ color: "#6F6F6F", fontSize: "14px" }}
    //       >
    //         {params.colDef.headerName}
    //       </Typography>
    //       <div className="position-relative" style={{ width: "170px" }}>
    //         <input
    //           type="text"
    //           className="form-control border mt-1"
    //           style={{ textIndent: "24px", boxShadow: "none" }}
    //           placeholder="Search"
    //           //value={filter.batchName}
    //           defaultValue={filter.batchName}
    //           onChange={(event) => handleFilterChange(event, "batchName")}
    //           onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
    //         />
    //         <SearchIcon
    //           sx={{
    //             color: "#6F6F6F",
    //             position: "absolute",
    //             top: "50%",
    //             left: "8px",
    //             transform: "translateY(-50%)",
    //           }}
    //         />
    //       </div>
    //     </div>
    //   ),
    // },
    {
      field: "ttbType",
      headerName: "TTB Type",
      flex: 1,
      minWidth: 150,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.ttbType || ''}
              // defaultValue={filter.ttbType}
              onChange={(event) => handleFilterChange(event, "ttbType")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "ttbClass",
      headerName: "TTB Class",
      flex: 1,
      minWidth: 150,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.ttbClass || ''}
              // defaultValue={filter.ttbClass}
              onChange={(event) => handleFilterChange(event, "ttbClass")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1,
      minWidth: 170,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.location || ''}
              // defaultValue={filter.location}
              onChange={(event) => handleFilterChange(event, "location")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "facility",
      headerName: "Facility",
      flex: 1,
      minWidth: 170,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.row.facilityName} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("facility") ? 0.5 : 1, cursor: isColumnFilterDisabled("facility") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.facility || ''}
              // defaultValue={filter.facility}
              disabled={isColumnFilterDisabled("facility")}
              title={isColumnFilterDisabled("facility") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "facility")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "rackhouse",
      headerName: "Warehouse",
      flex: 1,
      minWidth: 150,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.value} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.rackhouse || ''}
              // defaultValue={filter.rackhouse}
              onChange={(event) => handleFilterChange(event, "rackhouse")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
  ];

  const facilitiesColumns: GridColDef[] = [
    {
      field: "lotNo",
      headerName: "Lot ID",
      flex: 1,
      minWidth: 150,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("lotNo") ? 0.5 : 1, cursor: isColumnFilterDisabled("lotNo") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.lotNo || ''}
              // defaultValue={filter.lotNo}
              disabled={isColumnFilterDisabled("lotNo")}
              title={isColumnFilterDisabled("lotNo") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "lotNo")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "quantity",
      headerName: "Quantity",
      flex: 1,
      minWidth: 150,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      cellClassName: "info-dropdown",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="number"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.quantity || ''}
              onChange={(event) => handleFilterChange(event, "quantity")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
      renderCell: (params) => {
        return (
          <div>
            {params.row.quantity}
          </div>
        );
      },
    },
    {
      field: "productName",
      headerName: "Product Name",
      flex: 1,
      sortable: true,
      minWidth: 170,
      renderCell: (params) => {
        // const value = params.value;

        // const displayValue = value
        //   ? value.replace(/^Unknown/i, "-")
        //   : "-";

        return <CellWithTooltip value={params.value} />;
      },
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.title || ''}
              // defaultValue={filter.title}
              onChange={(event) => handleFilterChange(event, "title")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "age",
      headerName: "Age",
      flex: 1,
      minWidth: 170,
      sortable: true,
            renderCell: (params) => {
        const currentDate = new Date();
        const fillDate = new Date(params.row.fillDate); // Use the fillDate field

        // Calculate the difference in years and months
        let years = currentDate.getFullYear() - fillDate.getFullYear();
        let months = currentDate.getMonth() - fillDate.getMonth();

        // Adjust for negative months (if current month is earlier than the fill month)
        if (months < 0) {
          years--;
          months += 12;
        }
        let final_years = years + " years";
        let final_months = months + " months";
        // Format the result as 'X years Y months'
        return (
          <TwoLineCell
          value1={final_years}
          value2={final_months}
          />
        );
      },
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.age || ''}
              // defaultValue={filter.age}
              onChange={(event) => handleFilterChange(event, "age")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "mashBill",
      headerName: "Mash Bill",
      flex: 1,
      minWidth: 150,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("mashBill") ? 0.5 : 1, cursor: isColumnFilterDisabled("mashBill") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.mashBill || ''}
              // defaultValue={filter.mashBill}
              disabled={isColumnFilterDisabled("mashBill")}
              title={isColumnFilterDisabled("mashBill") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "mashBill")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "proof",
      headerName: "Proof",
      flex: 1,
      sortable: true,
      minWidth: 150,
      renderCell: (params) => <CellWithTooltip value={params.value === 0 ? "-" : CommonService.formatToSingleDecimal(params.value)} />,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="number"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.proof || ''}
              // defaultValue={filter.title}
              onChange={(event) => handleFilterChange(event, "proof")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "listedQuantity",
      headerName: "Listed Quantity",
      flex: 1,
      minWidth: 150,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      cellClassName: "info-dropdown",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="number"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.lotQuantity || ''}
              onChange={(event) => handleFilterChange(event, "lotQuantity")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
      renderCell: (params) => {
        return (
          <div>
            {params.row.listedQuantity + params.row.reservedQuantity}
          </div>
        );
      },
    },
    {
      field: "isNotAvailableForSell",
      headerName: "Unlisted Quantity",
      flex: 1,
      minWidth: 150,
      headerClassName: "table-header border-0 my-2 h-100",
      valueGetter: (value: any, row: any) => row.unlistedQuantity,
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="number"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              defaultValue={filter.initialQuantity || ''}
              // defaultValue={filter.initialQuantity} // For column-wise filter use unlistedQuantity to represent the quantity that is not available for sale
              onChange={(event) => handleFilterChange(event, "initialQuantity")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    },
    {
      field: "facility",
      headerName: "Facility",
      flex: 1,
      minWidth: 170,
      sortable: true,
      renderCell: (params) => <CellWithTooltip value={params.row.facilityName} />,
      //valueGetter: (value: any, row: any) => `${row.ecommUser.firstName || ''} ${row.ecommUser.lastName || ''}`,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          {/* <div className="position-relative" style={{ width: "100px" }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none", opacity: isColumnFilterDisabled("facility") ? 0.5 : 1, cursor: isColumnFilterDisabled("facility") ? "not-allowed" : undefined }}
              placeholder="Search"
              defaultValue={filter.facility || ''}
              // defaultValue={filter.facility}
              disabled={isColumnFilterDisabled("facility")}
              title={isColumnFilterDisabled("facility") ? "Controlled by Filter Panel" : undefined}
              onChange={(event) => handleFilterChange(event, "facility")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div> */}
        </div>
      ),
    }
  ];

  function routeBack() {
    if (currentPath.startsWith("/master/my-warehouse/")) {
      history.push("/master/company-dashboard/" + id);
    } else if (CommonService.isUser()) history.push("/user/my-warehouse");
    else history.push("/master/dashboard");
  }

  // Map filtered rows with unique IDs
  const tableDataWithIds = tableData.map((rowData, index) => ({
    ...rowData,
  }));

  const totalPages = Math.ceil(totalCount / pageSize);
  const WINDOW_SIZE = 7;
  const startPage = totalPages <= WINDOW_SIZE ? 0 : Math.min(Math.max(page - (WINDOW_SIZE - 1), 0), totalPages - WINDOW_SIZE);
  const endPage = Math.min(startPage + WINDOW_SIZE, totalPages);
  const pageNumbers = Array.from({ length: endPage - startPage }, (_, i) => startPage + i);

  const lotCards = React.useMemo(() => {
    if (!gridView || !tableData.length) return [];

    const map = new Map<string, any>();

    tableData.forEach((row: any) => {
      if (!map.has(row.lotNo)) {
        map.set(row.lotNo, {
          ...row,
          barrels: [],
          quantity: 0,
          listedQuantity: 0,
          unlistedQuantity: 0,
        });
      }

      const lot = map.get(row.lotNo);
      lot.barrels.push(row);
      lot.quantity += row.quantity || 0;
      lot.listedQuantity += row.listedQuantity || 0;
      lot.unlistedQuantity += row.unlistedQuantity || 0;
    });

    // Convert map to array
    const allLots = Array.from(map.values());

    // Limit to 24 for grid view
    return gridView ? allLots.slice(0, 12) : allLots;
  }, [tableData, gridView]);

  const handlePaginationChange = (newPage, newPageSize = pageSize) => {
    setGridLoading(true);

    setPage(newPage);
    setPageSize(newPageSize);

    fetchFacilityListing(newPage, newPageSize, filter, sortField, sortDirection).finally(() => {
      setGridLoading(false);
      // Scroll to top
      if (gridWrapperRef.current) {
        gridWrapperRef.current.scrollTo({
          top: 0,
          behavior: "smooth", // remove if you want instant scroll
        });
      }
    });
  };

  const onPaginationModelChange = (newPaginationModel) => {
    setPage(newPaginationModel.page);
    setPageSize(newPaginationModel.pageSize);

    // Fetch using the latest sorting values
    if (activeButtonRef.current === "product") {
      fetchProductListing(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
    } else if (activeButtonRef.current === "facilities") {
      fetchFacilityListing(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
    } else {
      fetchContainerListing(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
    }
  };

  


  const handleSortChange = (newSortModel) => {
    setSortModel(newSortModel);

    if (newSortModel.length > 0) {
      const newSortField = newSortModel[0].field;
      const rawDirection = newSortModel[0].sort;

      // Age: flip direction because older age = earlier fill_date
      const newSortDirection = newSortField === 'age'
        ? (rawDirection === 'asc' ? 'desc' : 'asc')
        : rawDirection;

      setSortField(newSortField);
      setSortDirection(newSortDirection);

      if (activeButtonRef.current === "product") {
        fetchProductListing(page, pageSize, filter, newSortField, newSortDirection);
      } else if (activeButtonRef.current === "facilities") {
        fetchFacilityListing(page, pageSize, filter, newSortField, newSortDirection);
      } else {
        fetchContainerListing(page, pageSize, filter, newSortField, newSortDirection);
      }
    }
  };

  const handleRowClick = (params) => {
    const rolePrefix = CommonService.isAdmin() ? "master" : "user";
    const linkPrefix =
      currentPath === "/user/inventory-change-requests" ||
        currentPath === "/master/inventory-change-requests"
        ? "compare-inventory"
        : "edit-inventory";

    pushWithActiveTab(`/${rolePrefix}/${linkPrefix}/${params.row.id}`);
  };

  const handleEditBarrelClick = (id: any) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    pushWithActiveTab(`${linkPrefix}/edit-barrel/${id}`);
  }

  const handleProofHistoryClick = (id: any, barrelNumber: any) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    pushWithActiveTab(`${linkPrefix}/proof-history/${id}`, {
      barrelNumber: barrelNumber
    });
  }

  const handleValuationHistoryClick = (id: any, barrelNumber: any) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    pushWithActiveTab(`${linkPrefix}/valuation-history/${id}`, {
      barrelNumber: barrelNumber
    });
  }

  const handleContainerEditBarrelClick = (id: any, barrelNumber: any, lotNo: any) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    pushWithActiveTab(`${linkPrefix}/container-detail/${id}`, {
      barrelNumber: barrelNumber,
      lotNo: lotNo
    });
  }

  const handleContainerViewBarrelClick = (params:any) => {
      const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
      pushWithActiveTab(`${linkPrefix}/container-detail/${params.row.id}`);
  }

  const handleEditLotLevelClick = (id: any) => {
    const linkPrefix = CommonService.isAdmin() ? "/master" : "/user";
    pushWithActiveTab(`${linkPrefix}/edit-lot-details/${id}`);
  }

  return (
    <div
      className={`usersList usersList__user ${!CommonService.isAdmin() ? "userBarrelList" : "barrelList"}`}
      style={{ paddingBottom: CommonService.isAdmin() ? 47 : "" }}
    >
      <div className="usersList__header--wrapper d-flex flex-wrap align-items-center w-100">
        <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2 position-relative">

          <div className="d-flex align-items-center gap-2 flex-wrap left-wrapper">

            {CommonService.isAdmin() && (
              <>
                <div className="back__button" onClick={routeBack}>

                  <IconButton
                    aria-label="ArrowBackIcon"
                    sx={{ backgroundColor: "#FFF" }}
                  >
                    <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                  </IconButton>
                </div>

                <div className="header--title">
                  <h1 className="title mb-0">
                    {(currentPath.includes("/inventory") && "Virtual Warehouse") ||
                      (currentPath.includes("/available-for-sell") &&
                        "Listed for Sale") ||
                      (currentPath.includes("/not-available-for-sell") &&
                        "Unlisted for Sale")}
                    <i className="bi bi-heart-fill"></i>
                  </h1>
                </div>
                <div className="divider mx-2"></div>
              </>
            )}
            {/* Filter button always visible; Export only when there's data */}
            <>              

              <button title="Export to Excel"
                className="primary-btn d-inline-flex align-items-center me-1"
                style={{ paddingTop: "4px", paddingLeft: 11 }}
                onClick={(e) => {
                  e.currentTarget.blur(); // Removes focus after clicking
                  exportInventoryData(page, pageSize, filter, sortField, sortDirection);
                }}
              >
                <FileDownloadOutlinedIcon sx={{ marginTop: "5.5px" }} />
                Export
              </button>
            </>
            {activeButtonRef.current === "barrel_lots" && <button title="Create Listing"
              className="primary-btn d-inline-flex align-items-center me-1 py-2"
              style={{ paddingTop: "4px", paddingLeft: 11 }}
              onClick={(e) => {
                handleCreateListing();
              }}
            >
              <AddSharpIcon sx={{ mr: 0.5 }} />
              <span style={{ marginTop: "-2.7px" }}>
                Create Listing {selectedRows.length > 0 && `(${selectedRows.length})`}
              </span>
            </button>}

            <button title="Add Inventory"
              className="primary-btn d-inline-flex align-items-center me-1 py-2"
              style={{ paddingTop: "4px", paddingLeft: 11 }}
              onClick={(e) => { handleAddInventory();}}
            >
              <AddSharpIcon sx={{ mr: 0.5 }} />
              <span style={{ marginTop: "-2.7px" }}>
                Add Inventory 
                {/* {selectedRows.length > 0 && `(${selectedRows.length})`} */}
              </span>
            </button>

          </div>

          <div className="d-flex justify-content-center flex-grow-1 mt-2 mt-xl-0" style={{ zIndex: 0 }}>
            <div
              className="btn-group user-activity-btn-grp flex-wrap"
              style={{ position: 'relative', transform: 'none', top: 'auto', left: 'auto' }}
              role="group"
              aria-label="Basic mixed styles example"
            >
              {/* {tableData.length > 0 || isLoading?     
                  <button title="Export to Excel"
            className="primary-btn d-inline-flex align-items-center me-1"
            style={{ paddingTop:"4px",paddingLeft:11}}
            onClick={(e) => {
              e.currentTarget.blur(); // Removes focus after clicking
              exportInventoryData(page, pageSize, filter, sortField, sortDirection);
            }}
              >
                <FileDownloadOutlinedIcon sx={{marginTop:"5.5px"}}/>
                Export
              </button>
              : null} */}

              <button
                className={`tab-btn d-inline-flex justify-content-between align-items-center
                    ${activeButtonRef.current === "barrel_lots"
                    ? "bg-theme"
                    : "bg-theme-white"
                  }`}
                onClick={() => {
                  activeButtonRef.current = "barrel_lots";
                  setActiveButton("barrel_lots");
                  setSortModel([{ field: 'lotNo', sort: 'asc' }]);
                  fetchContainerListing(page, pageSize, filter, "lotNo", sortDirection);
                }}
              >
                Container Lots
              </button>

              <button
                className={`tab-btn d-inline-flex justify-content-between align-items-center
                    ${activeButtonRef.current === "barrels" ? "bg-theme" : "bg-theme-white"}`}
                onClick={() => {
                  activeButtonRef.current = "barrels";
                  setActiveButton("barrels");
                  setSortModel([{ field: 'lotNo', sort: 'asc' }]);
                  fetchContainerListing(page, pageSize, filter, "lotNo", sortDirection);
                }}
              >
                Containers
              </button>

              <button
                className={`tab-btn d-inline-flex justify-content-between align-items-center
                    ${activeButtonRef.current === "product" ? "bg-theme" : "bg-theme-white"}`}
                onClick={() => {
                  activeButtonRef.current = "product";
                  setActiveButton("product");
                  setSortModel([{ field: 'productName', sort: 'asc' }]);
                  fetchProductListing(page, pageSize, filter, "productName", sortDirection);
                }}
              >
                Product
              </button>
              {CommonService.isAdmin() && (
                <button
                  className={`tab-btn d-inline-flex justify-content-between align-items-center
                    ${activeButtonRef.current === "facilities" ? "bg-theme" : "bg-theme-white"}`}
                  onClick={() => {
                    activeButtonRef.current = "facilities";
                    setActiveButton("facilities");
                    setSortModel([{ field: 'lotNo', sort: 'asc' }]);
                    fetchFacilityListing(page, pageSize, filter, "lotNo", sortDirection);
                    fetchFacilityBarrelSummary(filter);
                  }}
                >
                  Facilities
                </button>
              )}
            </div>
          </div>
          <div className="blank-div text-end">
          </div>
        </div>
      </div>
      <div className="user-table-container position-relative">
        <Accordion defaultActiveKey="0" className="filter-accordion mb-2">
          <Accordion.Item eventKey="0" className="filter-accordion-item">
            <Accordion.Header className="filter-accordion-header">
              <span className="accordion-filter-title">Filters</span>
              <button
                className="filter-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePanelClear();
                }}
              >
                Reset All
              </button>
            </Accordion.Header>
            <Accordion.Body className="filter-accordion-body p-0">
              <div className="filter-panel-accordion">

                <div className="filter-body">

                  {/* Company — admin only */}
                  {CommonService.isAdmin() && (
                    <div
                      className="filter-section order-4"
                      style={{ display: isFilterVisible("company") ? undefined : "none" }}
                    >
                      <div className="section-header">
                        <h4>Account Owner Name</h4>
                        <button className="section-btn" type="button" onClick={() => handleMultiselectReset(() => setPanelCompanies([]), "companyName")}>Reset</button>
                      </div>
                      <MultiSelectChipInput
                        selected={panelCompanies}
                        options={allCompanies}
                        placeholder="Select account owners"
                        searchPlaceholder="Search account owner"
                        onToggle={val => togglePanelItem(panelCompanies, setPanelCompanies, val)}
                        onSelectAll={() => selectAllPanelItems(allCompanies, setPanelCompanies, panelCompanies)}
                        onReset={() => setPanelCompanies([])}
                      />
                    </div>
                  )}
                  {/* Quantity */}
                  <div
                    className="filter-section order-2"
                    style={{ display: isFilterVisible("quantity") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>Quantity</h4>
                      <button className="section-btn" type="button" onClick={() => handleIndividualReset("quantity")}>Reset</button>
                    </div>
                    <input
                        type="number"
                        key={filterResetKey}
                        className="form-control border mt-1"
                        // style={{ textIndent: "24px", boxShadow: "none" }}
                        placeholder="Search"
                        defaultValue={filter.quantity || ''}
                        min={0}
                        onKeyDown={(e) => {
                          if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                            e.preventDefault();
                          }
                        }}
                        onChange={(event) => {
                          if (Number(event.target.value) < 0) return;
                          handleFilterChange(event, "quantity");
                        }}
                        onClick={(event) => event.stopPropagation()}
                    />
                  </div>

                  {/* Title */}
                  <div
                    className="filter-section order-3"
                    style={{ display: isFilterVisible("title") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>Title</h4>
                      <button className="section-btn" type="button" onClick={() => handleIndividualReset("title")}>Reset</button>
                    </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.title || ''}
                      // defaultValue={filter.title}
                      onChange={(event) => handleFilterChange(event, "title")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                   {/* Fill Date */}
                  <div
                    className="filter-section order-6"
                    style={{ display: isFilterVisible("fillDate") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Fill Date</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("fillDate")}>Reset</button>
                  </div>
                    <input
                      type="date"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      style={{ boxShadow: "none" }}
                      id="birthdate"
                      name="birthdate"
                      placeholder="MM/DD/YYYY"
                      defaultValue={filter.fillDate || ''}
                      // defaultValue={filter.fillDate}
                      onChange={(event) => handleFilterChange(event, "fillDate")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Listed Quantity */}
                  <div
                    className="filter-section order-7"
                    style={{ display: isFilterVisible("lotQuantity") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Listed Quantity</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("lotQuantity")}>Reset</button>
                  </div>
                    <input
                      type="number"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.lotQuantity || ''}
                      min={0}
                      onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                          e.preventDefault();
                        }
                      }}
                      onChange={(event) => {
                        if (Number(event.target.value) < 0) event.target.value = '';
                        handleFilterChange(event, "lotQuantity");
                      }}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Unlisted Quantity */}
                  <div
                    className="filter-section order-8"
                    style={{ display: isFilterVisible("initialQuantity") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Unlisted Quantity</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("initialQuantity")}>Reset</button>
                  </div>
                    <input
                      type="number"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.initialQuantity || ''}
                      min={0}
                      onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                          e.preventDefault();
                        }
                      }}
                      onChange={(event) => {
                        if (Number(event.target.value) < 0) event.target.value = '';
                        handleFilterChange(event, "initialQuantity");
                      }}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Warehouse */}
                  <div
                    className="filter-section order-10"
                    style={{ display: isFilterVisible("rackhouse") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Warehouse</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("rackhouse")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.rackhouse || ''}
                      // defaultValue={filter.rackhouse}
                      onChange={(event) => handleFilterChange(event, "rackhouse")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Age */}
                  <div
                    className="filter-section order-11"
                    style={{ display: isFilterVisible("age") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Age</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("age")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.age || ''}
                      // defaultValue={filter.age}
                      onChange={(event) => handleFilterChange(event, "age")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Container Id */}
                  <div
                    className="filter-section order-12"
                    style={{ display: isFilterVisible("barrelNumber") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Container Id</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("barrelNumber")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      //value={filter.title}
                      defaultValue={filter.barrelNumber}
                      onChange={(event) => handleFilterChange(event, "barrelNumber")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Proof */}
                  <div
                    className="filter-section order-15"
                    style={{ display: isFilterVisible("proof") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Proof</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("proof")}>Reset</button>
                  </div>
                    <input
                      type="number"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.proof || ''}
                      // defaultValue={filter.title}
                      min={0}
                      onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                          e.preventDefault();
                        }
                      }}
                      onChange={(event) => {
                        if (Number(event.target.value) < 0) event.target.value = '';
                        handleFilterChange(event, "proof");
                      }}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Container Condition */}
                  <div
                    className="filter-section order-16"
                    style={{ display: isFilterVisible("containerCooperage") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Container Condition</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("containerCooperage")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.containerCooperage || ''}
                      // defaultValue={filter.facility}
                      onChange={(event) => handleFilterChange(event, "containerCooperage")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Is Listed */}
                  <div
                    className="filter-section order-18"
                    style={{ display: isFilterVisible("isAvailableForSell") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Is Listed</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("isAvailableForSell")}>Reset</button>
                  </div>
                    <Form.Select
                      style={{
                        cursor: "pointer",
                        borderBottomColor: "#D1D1D1",
                        marginTop: "4px",
                      }}
                      key={filterResetKey}
                      defaultValue={filter.isAvailableForSell || ''}
                      className="form-control mb-1"
                      onChange={(event) => handleFilterChange(event, "isAvailableForSell")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    >
                      <option value="">Select Value</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </Form.Select>
                  </div>

                  {/* Container Cost */}
                  <div
                    className="filter-section order-19"
                    style={{ display: isFilterVisible("barrelCost") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Container Cost</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("barrelCost")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.barrelCost || ''}
                      // defaultValue={filter.price}
                      onChange={(event) => handleFilterChange(event, "barrelCost")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Sell Cost */}
                  <div
                    className="filter-section order-20"
                    style={{ display: isFilterVisible("sellCost") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Sell Cost</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("sellCost")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.sellCost || ''}
                      // defaultValue={filter.price}
                      onChange={(event) => handleFilterChange(event, "sellCost")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Is Filled */}
                  <div
                    className="filter-section order-21"
                    style={{ display: isFilterVisible("isFilled") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Is Filled</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("isFilled")}>Reset</button>
                  </div>
                    <Form.Select
                      style={{
                        cursor: "pointer",
                        borderBottomColor: "#D1D1D1",
                        marginTop: "4px",
                      }}
                      key={filterResetKey}
                      defaultValue={filter.isFilled || ''}
                      className="form-control mb-1"
                      onChange={(event) => handleFilterChange(event, "isFilled")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    >
                      <option value="">Select Value</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </Form.Select>
                  </div>
                  
                   {/* Container Description */}
                  <div
                    className="filter-section order-22"
                    style={{ display: isFilterVisible("description") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Container Description</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("description")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.description || ''}
                      // defaultValue={filter.description}
                      onChange={(event) => handleFilterChange(event, "description")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Product Name */}
                  <div
                    className="filter-section order-23"
                    style={{ display: isFilterVisible("productName") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Product Name</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("productName")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.productName || ''}
                      // defaultValue={filter.productName}
                      onChange={(event) => handleFilterChange(event, "productName")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* TTB Type */}
                  <div
                    className="filter-section order-24"
                    style={{ display: isFilterVisible("ttbType") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>TTB Type</h4>
                      <button className="section-btn" type="button" onClick={() => handleIndividualReset("ttbType")}>Reset</button>
                    </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.ttbType || ''}
                      // defaultValue={filter.ttbType}
                      onChange={(event) => handleFilterChange(event, "ttbType")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* TTB Class */}
                  <div
                    className="filter-section order-25"
                    style={{ display: isFilterVisible("ttbClass") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>TTB Class</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("ttbClass")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.ttbClass || ''}
                      // defaultValue={filter.ttbClass}
                      onChange={(event) => handleFilterChange(event, "ttbClass")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                   {/* Location */}
                  <div
                    className="filter-section order-26"
                    style={{ display: isFilterVisible("location") ? undefined : "none" }}
                  >
                  <div className="section-header">
                    <h4>Location</h4>
                    <button className="section-btn" type="button" onClick={() => handleIndividualReset("location")}>Reset</button>
                  </div>
                    <input
                      type="text"
                      key={filterResetKey}
                      className="form-control border mt-1"
                      // style={{ textIndent: "24px", boxShadow: "none" }}
                      placeholder="Search"
                      defaultValue={filter.location || ''}
                      // defaultValue={filter.location}
                      onChange={(event) => handleFilterChange(event, "location")}
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    />
                  </div>

                  {/* Container Owner */}
                  <div
                    className="filter-section order-14"
                    style={{ display: isFilterVisible("barrelOwner") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>Owner Name</h4>
                      <button className="section-btn" type="button" onClick={() => handleMultiselectReset(() => setPanelBarrelOwners([]), "barrelOwnerName")}>Reset</button>
                    </div>
                    <MultiSelectChipInput
                      selected={panelBarrelOwners}
                      options={allBarrelOwners}
                      placeholder="Select owner name"
                      searchPlaceholder="Search owner name"
                      onToggle={val => togglePanelItem(panelBarrelOwners, setPanelBarrelOwners, val)}
                      onSelectAll={() => selectAllPanelItems(allBarrelOwners, setPanelBarrelOwners, panelBarrelOwners)}
                      onReset={() => setPanelBarrelOwners([])}
                    />
                  </div>

                  {/* Facility */}
                  <div
                    className="filter-section order-9"
                    style={{ display: isFilterVisible("facility") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>Facility</h4>
                      <button className="section-btn" type="button" onClick={() => handleMultiselectReset(() => setPanelFacilities([]), "facility")}>Reset</button>
                    </div>
                    <MultiSelectChipInput
                      selected={panelFacilities}
                      options={validFacilities}
                      placeholder="Select facilities"
                      searchPlaceholder="Search facility"
                      onToggle={val => togglePanelItem(panelFacilities, setPanelFacilities, val)}
                      onSelectAll={() => selectAllPanelItems(validFacilities, setPanelFacilities, panelFacilities)}
                      onReset={() => setPanelFacilities([])}
                    />
                  </div>

                  {/* Lot ID */}
                  <div
                    className="filter-section order-1"
                    style={{ display: isFilterVisible("lotNo") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>Lot ID</h4>
                      <button className="section-btn" type="button" onClick={() => handleMultiselectReset(() => setPanelLotNos([]), "lotNo")}>Reset</button>
                    </div>
                    <MultiSelectChipInput
                      selected={panelLotNos}
                      options={allLotNos}
                      placeholder="Select lot IDs"
                      searchPlaceholder="Search lot ID"
                      onToggle={val => togglePanelItem(panelLotNos, setPanelLotNos, val)}
                      onSelectAll={() => selectAllPanelItems(allLotNos, setPanelLotNos, panelLotNos)}
                      onReset={() => setPanelLotNos([])}
                    />
                  </div>

                  {/* Producer */}
                  <div
                    className="filter-section order-5"
                    style={{ display: isFilterVisible("producer") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>Producer</h4>
                      <button className="section-btn" type="button" onClick={() => handleMultiselectReset(() => setPanelProducers([]), "producer")}>Reset</button>
                    </div>
                    <MultiSelectChipInput
                      selected={panelProducers}
                      options={allProducers}
                      placeholder="Select producers"
                      searchPlaceholder="Search producer"
                      onToggle={val => togglePanelItem(panelProducers, setPanelProducers, val)}
                      onSelectAll={() => selectAllPanelItems(allProducers, setPanelProducers, panelProducers)}
                      onReset={() => setPanelProducers([])}
                    />
                  </div>

                  {/* DSP */}
                  <div
                    className="filter-section order-17"
                    style={{ display: isFilterVisible("dsp") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>DSP</h4>
                      <button className="section-btn" type="button" onClick={() => handleMultiselectReset(() => setPanelDsps([]), "dsp")}>Reset</button>
                    </div>
                    <MultiSelectChipInput
                      selected={panelDsps}
                      options={allDsps}
                      placeholder="Select DSPs"
                      searchPlaceholder="Search DSP"
                      onToggle={val => togglePanelItem(panelDsps, setPanelDsps, val)}
                      onSelectAll={() => selectAllPanelItems(allDsps, setPanelDsps, panelDsps)}
                      onReset={() => setPanelDsps([])}
                    />
                  </div>

                  {/* Mash Bill */}
                  <div
                    className="filter-section order-13"
                    style={{ display: isFilterVisible("mashBill") ? undefined : "none" }}
                  >
                    <div className="section-header">
                      <h4>Mash Bill</h4>
                      <button className="section-btn" type="button" onClick={() => handleMultiselectReset(() => setPanelMashBills([]), "mashBill")}>Reset</button>
                    </div>
                    <MultiSelectChipInput
                      selected={panelMashBills}
                      options={allMashBills}
                      placeholder="Select mash bills"
                      searchPlaceholder="Search mash bill"
                      onToggle={val => togglePanelItem(panelMashBills, setPanelMashBills, val)}
                      onSelectAll={() => selectAllPanelItems(allMashBills, setPanelMashBills, panelMashBills)}
                      onReset={() => setPanelMashBills([])}
                    />
                  </div>

                </div>

                {/* Footer */}
                <div className="filter-bottom">
                  <div className="filter-actions">
                    <button className="filter-btn" onClick={handlePanelApply}>
                      <CheckIcon />
                      Apply
                    </button>
                  </div>
                </div>

              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <div className={`userTable facility-usertable ${gridView && activeButtonRef.current?.toLowerCase() === "facilities".toLowerCase() && 'facility-grid-view'} ${activeButtonRef.current?.toLowerCase() === "facilities".toLowerCase() && 'facility-table-view'}`}>
          {activeButtonRef.current?.toLowerCase() === "facilities".toLowerCase() && (
            <>
              <div className="facility-table-header">
                {/* <div className="header-left header-item"> */}

                  {/* Facility filter moved to the Filter Panel */}
                {/* </div> */}
                {(
                  <div className="header-item header-middle">
                    <div className="overview-wrapper">
                      <div className="overview-item">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.136 7.52702C15.6337 7.61232 14.9584 8.00143 14.6652 8.37461C14.4344 8.66826 14.2411 9.05236 14.1571 9.38374C14.0604 9.76548 14.0845 10.4255 14.2089 10.8007C14.3536 11.237 14.7205 11.7349 15.1021 12.0129C15.2863 12.147 15.4632 12.2656 15.4952 12.2764C15.5339 12.2895 15.4734 12.4294 15.3148 12.6938C14.1598 14.6191 13.1892 16.9677 12.652 19.1373C12.3533 20.3437 12.2293 21.1076 12.0598 22.7845C12.0355 23.0256 12.0313 23.0316 11.8636 23.0601C10.9021 23.2236 10.1892 23.9374 10.0269 24.899C9.84179 25.996 10.6322 27.1144 11.7478 27.3339L12.036 27.3907L12.0594 27.633C12.2122 29.2121 12.3483 30.0527 12.6482 31.2696C12.8672 32.1582 13.2881 33.458 13.6486 34.359C13.9909 35.2146 14.7388 36.748 15.1787 37.4965C15.3725 37.8264 15.5311 38.106 15.5311 38.1178C15.5311 38.1297 15.4207 38.2028 15.2857 38.2801C15.1507 38.3574 14.9124 38.5595 14.7561 38.7291C14.3018 39.222 14.0893 39.7605 14.0903 40.4157C14.091 40.8372 14.1453 41.1001 14.3071 41.4666L14.4271 41.7382L15.4561 41.733C16.1359 41.7296 16.4191 41.7146 16.2908 41.6889C16.0289 41.6363 15.8449 41.534 15.6423 41.3283C15.0459 40.723 15.2127 39.6834 15.9732 39.2661L16.1593 39.164L24.946 39.1517C33.565 39.1396 33.7365 39.1412 33.9374 39.2314C34.2504 39.3719 34.4418 39.5416 34.5817 39.8025C34.9988 40.5803 34.5442 41.5435 33.6913 41.6891C33.5433 41.7144 33.8197 41.7289 34.519 41.7326L35.5691 41.7382L35.6665 41.5611C35.9065 41.1249 35.9925 40.3914 35.8674 39.8489C35.7274 39.2418 35.245 38.5757 34.7244 38.2705C34.597 38.1958 34.4873 38.1305 34.4808 38.1255C34.4742 38.1205 34.5812 37.927 34.7184 37.6955C36.5367 34.6285 37.6915 31.0818 37.9402 27.7999L37.9709 27.3939L38.2559 27.3401C38.9193 27.2149 39.4893 26.7696 39.7981 26.1354C39.9426 25.8386 39.9738 25.7191 39.9944 25.383C40.0361 24.7044 39.8444 24.1677 39.393 23.6999C39.0453 23.3394 38.6678 23.1466 38.1397 23.0597L37.9712 23.032L37.9384 22.5961C37.78 20.4866 37.1893 18.0686 36.3111 15.9339C36.0025 15.1839 35.1865 13.4842 35.0224 13.2496C34.9742 13.1806 34.9347 13.1132 34.9347 13.0998C34.9347 13.0864 34.8286 12.9016 34.6988 12.6892C34.5691 12.4769 34.4696 12.2983 34.4778 12.2924C34.486 12.2866 34.5869 12.227 34.7021 12.16C35.4522 11.7239 35.9124 10.9272 35.9161 10.058C35.9171 9.83004 35.8952 9.5414 35.8676 9.41657C35.6705 8.52694 34.8659 7.73513 33.9669 7.54625C33.7924 7.50959 31.1659 7.49632 24.9864 7.50085C20.1827 7.5044 16.2 7.51616 16.136 7.52702ZM33.9399 8.79267C34.2066 8.90579 34.441 9.12254 34.5881 9.39205C34.7059 9.60777 34.7254 9.69387 34.7254 9.99777C34.7254 10.3067 34.7069 10.3853 34.581 10.6118C34.4187 10.9038 34.1339 11.1507 33.875 11.2236C33.7584 11.2565 30.8451 11.2724 24.977 11.2723L16.2524 11.2721L16.0197 11.1619C15.7591 11.0384 15.4661 10.736 15.356 10.4767C15.2629 10.2572 15.2637 9.74455 15.3576 9.51883C15.4647 9.26113 15.758 8.95756 16.0197 8.83362L16.2524 8.72343L25.0134 8.72296C32.6593 8.72253 33.7955 8.73141 33.9399 8.79267ZM19.6104 12.631C19.2312 14.4432 18.9279 16.1177 18.9279 16.3993C18.9279 16.8247 19.3883 17.1154 19.7563 16.9222C20.017 16.7854 20.0419 16.7163 20.2551 15.5404C20.3674 14.9209 20.5135 14.1483 20.5798 13.8236C20.646 13.4989 20.7337 13.0685 20.7746 12.8672L20.849 12.5011H22.6338H24.4186V17.7676V23.034H21.9525H19.4863L19.4872 22.7152C19.4885 22.2651 19.5679 20.8108 19.6316 20.0738C19.682 19.49 19.6798 19.4421 19.5958 19.2945C19.3577 18.8759 18.7747 18.8908 18.5461 19.3213C18.4701 19.4647 18.3713 20.6978 18.3387 21.9122L18.3086 23.034H15.7799H13.2511L13.2511 22.8805C13.2512 22.7961 13.284 22.4401 13.324 22.0894C13.6711 19.048 14.7879 15.8846 16.5214 13.0325L16.8443 12.5011H18.2409H19.6375L19.6104 12.631ZM29.2313 12.8435C29.9209 15.926 30.4258 19.5845 30.499 22.0303L30.5291 23.034H28.0555H25.5819V17.7676V12.5011H27.3683H29.1548L29.2313 12.8435ZM33.4291 12.911C34.8837 15.1998 36.0981 18.363 36.5366 21.0053C36.6643 21.7743 36.7495 22.5005 36.7495 22.8196V23.034H34.2421H31.7347L31.7037 22.2192C31.6177 19.9562 31.4032 18.0211 30.9514 15.4295C30.7696 14.3867 30.4654 12.8391 30.3921 12.5838C30.3699 12.5063 30.457 12.5011 31.7685 12.5011H33.1686L33.4291 12.911ZM38.2652 24.3378C38.4845 24.4434 38.7359 24.7408 38.7954 24.9649C38.9045 25.3762 38.6893 25.8697 38.3221 26.0501L38.1161 26.1514H25.007C12.213 26.1514 11.8938 26.1492 11.7253 26.0615C11.2792 25.8293 11.0853 25.3024 11.2757 24.8398C11.3718 24.6064 11.5136 24.4569 11.7388 24.3513C11.9183 24.2672 12.3881 24.2641 25.0165 24.2631C36.9315 24.2622 38.1222 24.2689 38.2652 24.3378ZM18.3235 28.0997C18.3246 29.7709 18.5963 32.3235 19.0488 34.9131C19.1918 35.7317 19.5329 37.4896 19.6101 37.8061L19.636 37.9123H18.2395H16.843L16.6129 37.5463C15.1322 35.1911 13.998 32.2845 13.512 29.5994C13.4042 29.0043 13.2511 27.7715 13.2511 27.4995V27.3794H15.7871H18.323L18.3235 28.0997ZM24.4186 32.6459V37.9123H22.6333H20.8479L20.8208 37.7588C20.806 37.6744 20.7093 37.1971 20.6061 36.6983C19.9665 33.6079 19.5988 30.7877 19.5064 28.265L19.4739 27.3794H21.9463H24.4186V32.6459ZM30.4974 28.4067C30.4799 28.9717 30.4472 29.636 30.4246 29.8828C30.2532 31.7586 30.2567 31.6706 30.3468 31.8404C30.5665 32.2544 31.1754 32.2383 31.4017 31.8124C31.4919 31.6425 31.7225 28.6134 31.7238 27.5802L31.7241 27.3794H34.25H36.7759L36.7404 27.8399C36.5978 29.6843 36.0727 31.8267 35.2613 33.874C34.8046 35.0264 33.7622 37.0542 33.2542 37.7784L33.1602 37.9123H31.7643C30.457 37.9123 30.3699 37.9071 30.3917 37.8297C30.4812 37.5127 30.9122 35.2914 31.0267 34.5571C31.0905 34.148 31.0307 33.9175 30.8255 33.781C30.5546 33.6007 30.1473 33.6674 29.9852 33.9184C29.9471 33.9774 29.8501 34.3953 29.7694 34.8472C29.6231 35.6678 29.3623 36.9912 29.2283 37.5935L29.1574 37.9123H27.3697H25.5819V32.6459V27.3794H28.0555H30.5291L30.4974 28.4067Z" fill="#9E874A" />
                          <path d="M34.519 41.7326C33.8197 41.7289 33.5433 41.7144 33.6913 41.6891L14.4271 41.7382C14.4271 41.7382 14.8858 42.5231 16.1593 42.4995C17.4328 42.4759 32.7245 42.4995 33.9374 42.4995C35.1502 42.4995 35.5691 41.7382 35.5691 41.7382L34.519 41.7326Z" fill="#9E874A" />
                        </svg>
                        <div className="overview-content">
                          <p>Total Containers</p>
                          <p className="price">{(facilitySummary?.totalBarrels ?? 0)}</p>
                        </div>
                      </div>
                      <div className="overview-divider"></div>
                      <div className="overview-item">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_16634_106329)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M45.3125 35.9381H46.875C47.2894 35.9381 47.6868 36.1027 47.9799 36.3957C48.2729 36.6887 48.4375 37.0862 48.4375 37.5006C48.4375 37.915 48.2729 38.3124 47.9799 38.6054C47.6868 38.8985 47.2894 39.0631 46.875 39.0631H3.125C2.7106 39.0631 2.31317 38.8985 2.02015 38.6054C1.72712 38.3124 1.5625 37.915 1.5625 37.5006C1.5625 37.0862 1.72712 36.6887 2.02015 36.3957C2.31317 36.1027 2.7106 35.9381 3.125 35.9381H4.6875V20.0142L3.45508 20.2779C3.34658 20.3011 3.23595 20.3129 3.125 20.3131C2.73942 20.3127 2.36759 20.1698 2.08103 19.9118C1.79446 19.6538 1.61341 19.299 1.5727 18.9156C1.53198 18.5321 1.63447 18.1472 1.86046 17.8348C2.08645 17.5224 2.41997 17.3046 2.79687 17.2232L10.7343 15.5224L11.4583 18.5562L7.8125 19.3365V35.9381H12.5V26.1953C12.5 25.7809 12.6646 25.3835 12.9576 25.0905C13.2507 24.7974 13.6481 24.6328 14.0625 24.6328H35.9375C36.3519 24.6328 36.7493 24.7974 37.0424 25.0905C37.3354 25.3835 37.5 25.7809 37.5 26.1953V35.9381H42.1875V11.9791L34.5784 13.6077L32.6485 10.8265L46.5469 7.84822C46.7496 7.79934 46.9601 7.79153 47.1659 7.82527C47.3717 7.85901 47.5687 7.93361 47.7452 8.04467C47.9218 8.15573 48.0743 8.30101 48.1938 8.47194C48.3133 8.64287 48.3973 8.836 48.441 9.03993C48.4847 9.24386 48.4871 9.45448 48.4481 9.65936C48.4091 9.86424 48.3295 10.0592 48.2139 10.2329C48.0984 10.4065 47.9492 10.5552 47.7753 10.6703C47.6014 10.7854 47.4062 10.8645 47.2012 10.9029L45.3125 11.3092V35.9381ZM15.625 29.6881H34.375V26.5631H15.625V29.6881ZM34.375 32.8131H15.625V35.9381H34.375V32.8131Z" fill="#007CB2" />
                            <path d="M17.0007 19.3639C17.0541 19.013 15.0218 16.5727 14.8408 16.1143C15.1053 15.592 15.3535 15.0978 15.6041 14.601C15.5716 14.5523 15.5716 14.5523 15.5368 14.5037C15.168 14.6804 14.8084 14.9237 14.3397 14.747C14.9012 13.8533 15.4533 12.9775 16.0379 12.0454C15.7642 11.943 15.5577 11.8662 15.3373 11.7817C16.5947 10.2453 17.8359 8.73191 19.1189 7.16733C18.4971 6.27621 17.8916 5.4107 17.2861 4.54263C17.249 4.56824 17.2583 4.56056 17.2188 4.58618C17.242 4.6758 17.2652 4.76798 17.2907 4.85759C17.4856 5.49521 17.6898 6.12771 17.873 6.76786C17.9079 6.88824 17.9032 7.07772 17.8452 7.17248C17.3975 7.90992 16.9334 8.62951 16.4741 9.35927C16.4416 9.41051 16.4277 9.4745 16.4045 9.53342C16.3442 9.51806 16.3488 9.52059 16.2885 9.50523C16.1586 7.09051 16.3186 4.71931 17.0193 2.35837C17.1051 2.44287 17.1724 2.48897 17.2188 2.55811C17.88 3.4979 18.5853 4.39924 19.098 5.47984C19.2557 5.81275 19.4692 5.93309 19.8009 5.92541C21.186 5.89725 22.5733 5.89979 23.9583 5.92541C24.2785 5.93051 24.4896 5.82043 24.6427 5.50035C25.1554 4.41975 25.8561 3.5158 26.5196 2.57347C26.566 2.5069 26.6054 2.43008 26.6843 2.37374C27.436 4.68859 27.5868 7.05725 27.4615 9.46682C27.4128 9.48476 27.4104 9.48476 27.3617 9.50269C26.9789 8.89323 26.617 8.2633 26.2064 7.68203C25.8955 7.24162 25.7656 6.84215 26.0138 6.28135C26.2156 5.82554 26.3247 5.3083 26.4755 4.81665C26.5057 4.71931 26.5289 4.61945 26.5057 4.48631C25.8909 5.36461 25.2761 6.24294 24.6589 7.12892C25.9326 8.68324 27.1808 10.2043 28.4568 11.7612C28.1923 11.8662 27.9789 11.9481 27.7167 12.0505C28.2967 12.9698 28.8465 13.843 29.4172 14.747C28.9509 14.9057 28.5913 14.7111 28.176 14.4474C28.3222 15.1234 28.6006 15.6022 28.9393 16.0375C28.7398 16.5651 26.9163 18.949 26.9743 19.3639C27.2898 19.1641 29.8812 16.6035 30.1596 16.2321C30.2269 16.1451 30.2547 16.0119 30.3104 15.8762C30.5819 15.8276 30.8788 15.7712 31.25 15.7047C30.612 14.6932 30.0019 13.7278 29.3708 12.7266C29.691 12.6088 29.981 12.5013 30.3081 12.3809C29.626 11.5845 28.9788 10.8291 28.364 10.1121C28.7212 6.54508 28.1992 3.25718 27.0462 0C25.9465 1.5902 24.8817 3.13426 23.7959 4.70141H19.9564C18.8683 3.12915 17.7988 1.58251 16.7038 0.00257282C15.5508 3.26486 15.0288 6.55023 15.3744 9.99946C14.7295 10.783 14.0915 11.5564 13.4117 12.3783C13.776 12.5089 14.0613 12.6088 14.3815 12.724C13.7481 13.7252 13.138 14.6906 12.5 15.7047C12.8689 15.7738 13.1658 15.8276 13.4396 15.8762C13.4929 16.0094 13.5208 16.14 13.588 16.227C13.8711 16.606 16.6899 19.2538 16.9938 19.3639H17.0007Z" fill="#007CB2" />
                            <path d="M26.156 15.8404C26.1212 15.9915 26.1027 16.1426 26.1096 16.2937C26.1212 16.5216 26.0771 16.6855 26.0771 16.6957C26.0609 16.9364 25.7709 17.6688 24.8731 19.4305C24.6411 19.2206 24.3116 18.862 24.0472 18.3141C23.9149 18.0375 23.8268 17.7763 23.7688 17.5561C23.7154 17.574 23.6806 17.6329 23.6876 17.6995C23.7084 17.9249 23.7178 18.1553 23.7734 18.3678C23.8755 18.7468 24.0008 19.1207 24.1539 19.474C24.5483 20.3882 23.7966 21.6788 23.0032 21.5969C22.2237 21.5149 21.4349 21.5892 20.6507 21.5764C19.9431 21.5661 19.3423 20.6315 19.5325 19.8095C19.6416 19.3409 19.8132 18.8953 19.9663 18.4421C20.0777 18.1092 20.0963 17.8019 19.9803 17.5561C19.9292 17.7559 19.8596 17.9786 19.7599 18.2116C19.4931 18.8313 19.1404 19.2461 18.8806 19.4971C18.2333 18.1655 17.8134 17.1566 17.7415 16.9057C17.6464 16.5779 17.6464 16.3347 17.6464 16.3347C17.6487 16.1682 17.6324 16.0018 17.6255 15.8353L17.5304 15.8276C17.4793 16.0939 17.4051 16.3551 17.3842 16.6266C17.3239 17.4178 17.5768 18.0426 17.9573 18.8851C18.6068 20.3216 18.9316 21.0386 19.2147 21.3741C19.558 21.7838 20.5394 22.9566 21.9871 22.9156C23.3117 22.8797 24.2096 21.8452 24.4276 21.5738C24.7757 21.1436 24.5669 21.2102 25.648 19.1591C25.9959 18.501 26.17 18.2014 26.2674 17.6867C26.4136 16.939 26.2813 16.2681 26.1584 15.8379L26.156 15.8404Z" fill="#007CB2" />
                            <path d="M23.152 19.4662C23.1195 19.6685 22.9734 19.7991 22.6973 20.0475C22.4212 20.2934 22.2194 20.721 21.9386 20.7184C21.6486 20.7184 21.4422 20.2805 21.129 19.9835C20.8784 19.7479 20.7531 19.6301 20.7253 19.4637C20.6464 18.9874 21.2635 18.2115 21.9386 18.2115C22.6068 18.2115 23.2286 18.9746 23.152 19.4637V19.4662Z" fill="#007CB2" />
                            <path d="M18.3324 11.861C18.4298 11.9506 20.2673 12.4833 20.2673 12.4833L20.8473 13.9966L18.8149 13.2847L18.3324 11.861Z" fill="#007CB2" />
                            <path d="M25.4306 11.861C25.3332 11.9506 23.4958 12.4833 23.4958 12.4833L22.9158 13.9966L24.9481 13.2847L25.4306 11.861Z" fill="#007CB2" />
                            <path d="M17.0007 19.3639C17.0541 19.013 15.0218 16.5727 14.8408 16.1143C15.1053 15.592 15.3535 15.0978 15.6041 14.601C15.5716 14.5523 15.5716 14.5523 15.5368 14.5037C15.168 14.6804 14.8084 14.9237 14.3397 14.747C14.9012 13.8533 15.4533 12.9775 16.0379 12.0454C15.7642 11.943 15.5577 11.8662 15.3373 11.7817C16.5947 10.2453 17.8359 8.73191 19.1189 7.16733C18.4971 6.27621 17.8916 5.4107 17.2861 4.54263C17.249 4.56824 17.2583 4.56056 17.2188 4.58618C17.242 4.6758 17.2652 4.76798 17.2907 4.85759C17.4856 5.49521 17.6898 6.12771 17.873 6.76786C17.9079 6.88824 17.9032 7.07772 17.8452 7.17248C17.3975 7.90992 16.9334 8.62951 16.4741 9.35927C16.4416 9.41051 16.4277 9.4745 16.4045 9.53342C16.3442 9.51806 16.3488 9.52059 16.2885 9.50523C16.1586 7.09051 16.3186 4.71931 17.0193 2.35837C17.1051 2.44287 17.1724 2.48897 17.2188 2.55811C17.88 3.4979 18.5853 4.39924 19.098 5.47984C19.2557 5.81275 19.4692 5.93309 19.8009 5.92541C21.186 5.89725 22.5733 5.89979 23.9583 5.92541C24.2785 5.93051 24.4896 5.82043 24.6427 5.50035C25.1554 4.41975 25.8561 3.5158 26.5196 2.57347C26.566 2.5069 26.6054 2.43008 26.6843 2.37374C27.436 4.68859 27.5868 7.05725 27.4615 9.46682C27.4128 9.48476 27.4104 9.48476 27.3617 9.50269C26.9789 8.89323 26.617 8.2633 26.2064 7.68203C25.8955 7.24162 25.7656 6.84215 26.0138 6.28135C26.2156 5.82554 26.3247 5.3083 26.4755 4.81665C26.5057 4.71931 26.5289 4.61945 26.5057 4.48631C25.8909 5.36461 25.2761 6.24294 24.6589 7.12892C25.9326 8.68324 27.1808 10.2043 28.4568 11.7612C28.1923 11.8662 27.9789 11.9481 27.7167 12.0505C28.2967 12.9698 28.8465 13.843 29.4172 14.747C28.9509 14.9057 28.5913 14.7111 28.176 14.4474C28.3222 15.1234 28.6006 15.6022 28.9393 16.0375C28.7398 16.5651 26.9163 18.949 26.9743 19.3639C27.2898 19.1641 29.8812 16.6035 30.1596 16.2321C30.2269 16.1451 30.2547 16.0119 30.3104 15.8762C30.5819 15.8276 30.8788 15.7712 31.25 15.7047C30.612 14.6932 30.0019 13.7278 29.3708 12.7266C29.691 12.6088 29.981 12.5013 30.3081 12.3809C29.626 11.5845 28.9788 10.8291 28.364 10.1121C28.7212 6.54508 28.1992 3.25718 27.0462 0C25.9465 1.5902 24.8817 3.13426 23.7959 4.70141H19.9564C18.8683 3.12915 17.7988 1.58251 16.7038 0.00257282C15.5508 3.26486 15.0288 6.55023 15.3744 9.99946C14.7295 10.783 14.0915 11.5564 13.4117 12.3783C13.776 12.5089 14.0613 12.6088 14.3815 12.724C13.7481 13.7252 13.138 14.6906 12.5 15.7047C12.8689 15.7738 13.1658 15.8276 13.4396 15.8762C13.4929 16.0094 13.5208 16.14 13.588 16.227C13.8711 16.606 16.6899 19.2538 16.9938 19.3639H17.0007Z" stroke="#007CB2" stroke-width="0.5" />
                            <path d="M26.156 15.8404C26.1212 15.9915 26.1027 16.1426 26.1096 16.2937C26.1212 16.5216 26.0771 16.6855 26.0771 16.6957C26.0609 16.9364 25.7709 17.6688 24.8731 19.4305C24.6411 19.2206 24.3116 18.862 24.0472 18.3141C23.9149 18.0375 23.8268 17.7763 23.7688 17.5561C23.7154 17.574 23.6806 17.6329 23.6876 17.6995C23.7084 17.9249 23.7178 18.1553 23.7734 18.3678C23.8755 18.7468 24.0008 19.1207 24.1539 19.474C24.5483 20.3882 23.7966 21.6788 23.0032 21.5969C22.2237 21.5149 21.4349 21.5892 20.6507 21.5764C19.9431 21.5661 19.3423 20.6315 19.5325 19.8095C19.6416 19.3409 19.8132 18.8953 19.9663 18.4421C20.0777 18.1092 20.0963 17.8019 19.9803 17.5561C19.9292 17.7559 19.8596 17.9786 19.7599 18.2116C19.4931 18.8313 19.1404 19.2461 18.8806 19.4971C18.2333 18.1655 17.8134 17.1566 17.7415 16.9057C17.6464 16.5779 17.6464 16.3347 17.6464 16.3347C17.6487 16.1682 17.6324 16.0018 17.6255 15.8353L17.5304 15.8276C17.4793 16.0939 17.4051 16.3551 17.3842 16.6266C17.3239 17.4178 17.5768 18.0426 17.9573 18.8851C18.6068 20.3216 18.9316 21.0386 19.2147 21.3741C19.558 21.7838 20.5394 22.9566 21.9871 22.9156C23.3117 22.8797 24.2096 21.8452 24.4276 21.5738C24.7757 21.1436 24.5669 21.2102 25.648 19.1591C25.9959 18.501 26.17 18.2014 26.2674 17.6867C26.4136 16.939 26.2813 16.2681 26.1584 15.8379L26.156 15.8404Z" stroke="#007CB2" stroke-width="0.5" />
                            <path d="M23.152 19.4662C23.1195 19.6685 22.9734 19.7991 22.6973 20.0475C22.4212 20.2934 22.2194 20.721 21.9386 20.7184C21.6486 20.7184 21.4422 20.2805 21.129 19.9835C20.8784 19.7479 20.7531 19.6301 20.7253 19.4637C20.6464 18.9874 21.2635 18.2115 21.9386 18.2115C22.6068 18.2115 23.2286 18.9746 23.152 19.4637V19.4662Z" stroke="#007CB2" stroke-width="0.5" />
                            <path d="M18.3324 11.861C18.4298 11.9506 20.2673 12.4833 20.2673 12.4833L20.8473 13.9966L18.8149 13.2847L18.3324 11.861Z" stroke="#007CB2" stroke-width="0.5" />
                            <path d="M25.4306 11.861C25.3332 11.9506 23.4958 12.4833 23.4958 12.4833L22.9158 13.9966L24.9481 13.2847L25.4306 11.861Z" stroke="#007CB2" stroke-width="0.5" />
                          </g>
                          <defs>
                            <clipPath id="clip0_16634_106329">
                              <rect width="50" height="50" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                        <div className="overview-content">
                          <p>WDTS Facilities</p>
                          <p className="price">{facilitySummary?.wdtsFacilities ?? 0}</p>
                        </div>
                      </div>
                      <div className="overview-divider"></div>
                      <div className="overview-item">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_16634_106340)">
                            <g clip-path="url(#clip1_16634_106340)">
                              <path d="M46.875 35.9381H45.3125V11.3092L47.2011 10.9029C47.4061 10.8645 47.6014 10.7854 47.7752 10.6703C47.9492 10.5552 48.0984 10.4065 48.2139 10.2329C48.3295 10.0592 48.4091 9.86423 48.4481 9.65936C48.4871 9.45448 48.4846 9.24387 48.441 9.03993C48.3974 8.83599 48.3133 8.64287 48.1937 8.47194C48.0742 8.30101 47.9218 8.15573 47.7453 8.04467C47.5688 7.93361 47.3717 7.85901 47.1659 7.82527C46.9601 7.79153 46.7496 7.79933 46.5469 7.84822L2.79688 17.2232C2.41997 17.3046 2.08645 17.5224 1.86046 17.8347C1.63447 18.1472 1.53197 18.5321 1.5727 18.9156C1.61341 19.299 1.79446 19.6539 2.08102 19.9119C2.36759 20.1697 2.73942 20.3127 3.125 20.3131C3.23595 20.3129 3.34658 20.3011 3.45508 20.2779L4.6875 20.0142V35.9381H3.125C2.7106 35.9381 2.31317 36.1027 2.02015 36.3957C1.72712 36.6887 1.5625 37.0861 1.5625 37.5006C1.5625 37.915 1.72712 38.3124 2.02015 38.6055C2.31317 38.8985 2.7106 39.0631 3.125 39.0631H46.875C47.2894 39.0631 47.6869 38.8985 47.9799 38.6055C48.2729 38.3124 48.4375 37.915 48.4375 37.5006C48.4375 37.0861 48.2729 36.6887 47.9799 36.3957C47.6869 36.1027 47.2894 35.9381 46.875 35.9381ZM7.8125 19.3365L42.1875 11.9791V35.9381H37.5V25.0006C37.5 24.5861 37.3354 24.1887 37.0424 23.8957C36.7494 23.6027 36.3519 23.4381 35.9375 23.4381H14.0625C13.6481 23.4381 13.2506 23.6027 12.9576 23.8957C12.6646 24.1887 12.5 24.5861 12.5 25.0006V35.9381H7.8125V19.3365ZM34.375 29.6881H15.625V26.5631H34.375V29.6881ZM15.625 32.8131H34.375V35.9381H15.625V32.8131Z" fill="#9E874A" />
                            </g>
                          </g>
                          <defs>
                            <clipPath id="clip0_16634_106340">
                              <rect width="50" height="50" fill="white" />
                            </clipPath>
                            <clipPath id="clip1_16634_106340">
                              <rect width="50" height="50" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <div className="overview-content">
                          <p>External Facilities</p>
                          <p className="price">{facilitySummary?.externalFacilities ?? 0}</p>
                        </div>
                      </div>
                      <div className="overview-divider"></div>
                        <div className="overview-item">
                          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M45.3125 35.9381H46.875C47.2894 35.9381 47.6868 36.1027 47.9799 36.3957C48.2729 36.6887 48.4375 37.0862 48.4375 37.5006C48.4375 37.915 48.2729 38.3124 47.9799 38.6054C47.6868 38.8985 47.2894 39.0631 46.875 39.0631H3.125C2.7106 39.0631 2.31317 38.8985 2.02015 38.6054C1.72712 38.3124 1.5625 37.915 1.5625 37.5006C1.5625 37.0862 1.72712 36.6887 2.02015 36.3957C2.31317 36.1027 2.7106 35.9381 3.125 35.9381H4.6875V20.0142L3.45508 20.2779C3.34658 20.3011 3.23595 20.3129 3.125 20.3131C2.73942 20.3127 2.36759 20.1698 2.08103 19.9118C1.79446 19.6538 1.61341 19.299 1.5727 18.9156C1.53198 18.5321 1.63447 18.1472 1.86046 17.8348C2.08645 17.5224 2.41997 17.3046 2.79687 17.2232L10.7343 15.5224L11.4583 18.5562L7.8125 19.3365V35.9381H12.5V26.1953C12.5 25.7809 12.6646 25.3835 12.9576 25.0905C13.2507 24.7974 13.6481 24.6328 14.0625 24.6328H35.9375C36.3519 24.6328 36.7493 24.7974 37.0424 25.0905C37.3354 25.3835 37.5 25.7809 37.5 26.1953V35.9381H42.1875V11.9791L34.5784 13.6077L32.6485 10.8265L46.5469 7.84822C46.7496 7.79934 46.9601 7.79153 47.1659 7.82527C47.3717 7.85901 47.5687 7.93361 47.7452 8.04467C47.9218 8.15573 48.0743 8.30101 48.1938 8.47194C48.3133 8.64287 48.3973 8.836 48.441 9.03993C48.4847 9.24386 48.4871 9.45448 48.4481 9.65936C48.4091 9.86424 48.3295 10.0592 48.2139 10.2329C48.0984 10.4065 47.9492 10.5552 47.7753 10.6703C47.6014 10.7854 47.4062 10.8645 47.2012 10.9029L45.3125 11.3092V35.9381ZM15.625 29.6881H34.375V26.5631H15.625V29.6881ZM34.375 32.8131H15.625V35.9381H34.375V32.8131Z" fill="#9747FF" />
                            <path d="M28.6719 7.17391C28.6719 9.80799 26.3778 11.9884 23.4219 12.3072V13.087C23.4219 13.283 23.3429 13.471 23.2022 13.6096C23.0616 13.7482 22.8708 13.8261 22.6719 13.8261C22.473 13.8261 22.2822 13.7482 22.1415 13.6096C22.0009 13.471 21.9219 13.283 21.9219 13.087V11.6087C21.9219 11.4127 22.0009 11.2247 22.1415 11.0861C22.2822 10.9474 22.473 10.8696 22.6719 10.8696C25.1534 10.8696 27.1719 9.21206 27.1719 7.17391C27.1719 5.13576 25.1534 3.47826 22.6719 3.47826C20.1903 3.47826 18.1719 5.13576 18.1719 7.17391C18.1719 7.36994 18.0929 7.55794 17.9522 7.69656C17.8116 7.83517 17.6208 7.91304 17.4219 7.91304C17.223 7.91304 17.0322 7.83517 16.8915 7.69656C16.7509 7.55794 16.6719 7.36994 16.6719 7.17391C16.6719 4.32087 19.3634 2 22.6719 2C25.9803 2 28.6719 4.32087 28.6719 7.17391ZM22.6719 16.0435C22.3752 16.0435 22.0852 16.1302 21.8385 16.2926C21.5918 16.455 21.3996 16.6859 21.2861 16.956C21.1725 17.2261 21.1428 17.5234 21.2007 17.8101C21.2586 18.0969 21.4014 18.3603 21.6112 18.567C21.821 18.7738 22.0883 18.9146 22.3792 18.9716C22.6702 19.0286 22.9718 18.9994 23.2459 18.8875C23.52 18.7756 23.7543 18.5861 23.9191 18.343C24.0839 18.0999 24.1719 17.8141 24.1719 17.5217C24.1719 17.1297 24.0138 16.7537 23.7325 16.4765C23.4512 16.1992 23.0697 16.0435 22.6719 16.0435Z" fill="#9747FF" />
                          </svg>

                          <div className="overview-content">
                            <p>No Facility Containers</p>
                            <p className="price">{(facilitySummary?.noFacilityContainers ?? 0)}</p>
                          </div>

                      
                        </div>
                    </div>
                  </div>
                )}
                <div className="header-right header-item">
                  <div className="view__type--select">
                    <ButtonGroup>
                      <Button variant="link"
                        aria-label="View as" disabled
                        className='d-none d-md-block'
                      >
                        View As
                      </Button>
                      <Button aria-label="Grid" className='ms-1 ms-sm-0 me-2'
                        onClick={() => {
                          switchView("grid");
                        }} style={{ backgroundColor: gridView === true ? '#0C3344' : '#D7D7D7' }} >
                        <GridViewIcon style={{ color: gridView === true ? 'white' : 'inherit' }} />
                      </Button>
                      <Button
                        aria-label="Table"
                        onClick={() => {
                          switchView("table");
                        }}
                        style={{ backgroundColor: gridView === false ? '#0C3344' : '#D7D7D7' }} >
                        <ListSharpIcon style={{ color: gridView === false ? 'white' : 'inherit' }} />
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
              </div>
            </>
          )}
          {gridView && activeButtonRef.current?.toLowerCase() === "facilities".toLowerCase() ? (
            <div className="grid-view-wrapper" ref={gridWrapperRef}>
              {/* LOADER */}
              {gridLoading && (
                <div className="grid-loader">
                  <div className="loader-wrapper">

                  </div>
                  Please Wait...
                </div>
              )}
              {!gridLoading && (
                <div className="barrel-card-view">
                  <div className="row">
                    {lotCards?.map((item: any) => (
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xxl-2">
                        <div className="card-item h-100">
                          <div className="image-wrapper">
                            <BarrelImage fillDate={item.fillDate} />
                          </div>
                          <div className="card-content">
                            <div className="card-title">
                              <h3>
                                {item.productName
                                  ? item.productName.replace(/^unknown/i, "-")
                                  : "-"}
                              </h3>
                            </div>
                            <p className="barrel-number">
                              {item.lotNo || "-"}
                            </p>
                            <div className="barrel-details-wrapper">
                              <div className="barrel-detail-item">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.1977 12.285L8.72204 8L13.1977 3.715C13.2002 3.71214 13.2029 3.70942 13.2058 3.70688C13.3455 3.56702 13.4407 3.38888 13.4793 3.19496C13.5178 3.00104 13.498 2.80005 13.4224 2.61738C13.3467 2.43471 13.2186 2.27857 13.0542 2.16868C12.8899 2.05879 12.6966 2.00009 12.4989 2H3.49891C3.30125 2.00022 3.10809 2.059 2.94382 2.16894C2.77955 2.27887 2.65155 2.43502 2.57598 2.61767C2.5004 2.80031 2.48065 3.00125 2.51922 3.19512C2.55779 3.38898 2.65294 3.56706 2.79266 3.70688L2.80016 3.715L7.27579 8L2.80016 12.285L2.79266 12.2931C2.65294 12.4329 2.55779 12.611 2.51922 12.8049C2.48065 12.9987 2.5004 13.1997 2.57598 13.3823C2.65155 13.565 2.77955 13.7211 2.94382 13.8311C3.10809 13.941 3.30125 13.9998 3.49891 14H12.4989C12.6967 14 12.89 13.9414 13.0545 13.8316C13.2189 13.7217 13.3471 13.5656 13.4229 13.3829C13.4986 13.2002 13.5184 12.9992 13.4799 12.8052C13.4414 12.6112 13.3462 12.433 13.2064 12.2931C13.2033 12.2906 13.2004 12.2879 13.1977 12.285ZM12.4989 3L7.99891 7.3075L3.49891 3H12.4989ZM3.49891 13L7.99891 8.6925L12.4989 13H3.49891Z" fill="#9E874A" />
                                </svg>
                                <span>{getSpiritAgeFromFillDate(item.fillDate)}</span>
                              </div>
                              {item.mashBill?.toUpperCase() !== "UNKNOWN" && <div className="barrel-detail-item">
                                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.7383 3.44974C10.4829 3.44974 10.2297 3.4961 9.9918 3.58646C9.65617 2.9097 8.97813 2.57337 8.94719 2.55833C8.92114 2.54566 8.89241 2.53906 8.86328 2.53906C8.83415 2.53906 8.80542 2.54566 8.77937 2.55833C8.7482 2.57337 8.07039 2.9097 7.73477 3.58646C7.49686 3.4961 7.24369 3.44974 6.98828 3.44974C6.93855 3.44974 6.89086 3.46895 6.8557 3.50313C6.82054 3.53732 6.80078 3.58368 6.80078 3.63203V5.45495C6.80078 5.98676 7.01808 6.4968 7.40487 6.87285C7.79167 7.24889 8.31627 7.46016 8.86328 7.46016C9.41029 7.46016 9.9349 7.24889 10.3217 6.87285C10.7085 6.4968 10.9258 5.98676 10.9258 5.45495V3.63203C10.9258 3.58368 10.906 3.53732 10.8709 3.50313C10.8357 3.46895 10.788 3.44974 10.7383 3.44974ZM8.67578 7.08555C8.26344 7.04022 7.88267 6.84898 7.60604 6.54826C7.32941 6.24755 7.17626 5.85839 7.17578 5.45495V5.10039C7.58812 5.14571 7.96889 5.33696 8.24552 5.63767C8.52215 5.93839 8.6753 6.32755 8.67578 6.73099V7.08555ZM8.67578 5.57936C8.50383 5.34109 8.28059 5.14206 8.02155 4.99612C7.76252 4.85017 7.47392 4.7608 7.17578 4.73421V3.82435C7.58812 3.86967 7.96889 4.06092 8.24552 4.36163C8.52215 4.66235 8.6753 5.05151 8.67578 5.45495V5.57936ZM8.06992 3.74847C8.28602 3.31074 8.68891 3.03457 8.86328 2.93044C9.03766 3.0348 9.44055 3.31097 9.65641 3.74847C9.30978 3.95703 9.03395 4.26015 8.86328 4.62005C8.6926 4.26008 8.41667 3.95695 8.06992 3.74847ZM10.5508 5.45495C10.5503 5.85839 10.3972 6.24755 10.1205 6.54826C9.84389 6.84898 9.46312 7.04022 9.05078 7.08555V6.73099C9.05126 6.32755 9.20441 5.93839 9.48104 5.63767C9.75767 5.33696 10.1384 5.14571 10.5508 5.10039V5.45495ZM10.5508 4.73421C10.2526 4.7608 9.96404 4.85017 9.70501 4.99612C9.44598 5.14206 9.22273 5.34109 9.05078 5.57936V5.45495C9.05126 5.05151 9.20441 4.66235 9.48104 4.36163C9.75767 4.06092 10.1384 3.86967 10.5508 3.82435V4.73421Z" fill="#9E874A" />
                                  <path d="M13.1768 0.103516C13.7815 0.103718 14.2309 0.714596 14.0635 1.32031L14.0645 1.32129L11.9912 9.44531C12.4225 9.67213 12.7148 10.1512 12.7148 10.7031V12.8906C12.7148 13.6774 12.141 14.3025 11.3906 14.3027H5.6748C4.95104 14.3027 4.34961 13.6789 4.34961 12.8906V10.7031C4.34961 10.1447 4.67193 9.63701 5.13379 9.41113L4.84277 5.99023H3.02051C2.39759 5.99013 1.90039 5.44698 1.90039 4.79688V1.29688C1.90039 0.646769 2.39759 0.103616 3.02051 0.103516H13.1768ZM5.6748 9.92773C5.27713 9.92773 4.95801 10.2595 4.95801 10.7031V12.8906C4.95801 13.3342 5.27713 13.666 5.6748 13.666H11.3906C11.7881 13.6658 12.1064 13.3341 12.1064 12.8906V10.7031C12.1064 10.2597 11.7881 9.92793 11.3906 9.92773H5.6748ZM8.53223 10.8223C9.05316 10.8223 9.44922 11.2561 9.44922 11.7969C9.44922 12.3377 9.05316 12.7715 8.53223 12.7715C8.01136 12.7714 7.61621 12.3376 7.61621 11.7969C7.61621 11.2561 8.01136 10.8223 8.53223 10.8223ZM8.53223 11.459C8.36426 11.4591 8.22363 11.5994 8.22363 11.7969C8.22363 11.9943 8.36426 12.1347 8.53223 12.1348C8.70025 12.1348 8.84082 11.9944 8.84082 11.7969C8.84082 11.5994 8.70025 11.459 8.53223 11.459ZM5.74121 9.29102H11.4141L12.1611 6.30371C12.1618 6.30051 12.162 6.29816 12.1621 6.29785C12.1634 6.29206 12.1652 6.28535 12.167 6.27832C12.1708 6.26391 12.1756 6.24483 12.1816 6.22363C12.1938 6.18112 12.2096 6.12666 12.2256 6.07324C12.2416 6.01963 12.2575 5.96627 12.2695 5.92676C12.2754 5.90735 12.2807 5.8913 12.2842 5.87988C12.2859 5.87424 12.2871 5.86928 12.2881 5.86621C12.2886 5.86467 12.2888 5.8631 12.2891 5.8623V5.86133L12.9463 3.26172C12.9466 3.25958 12.9473 3.25785 12.9473 3.25781C12.9475 3.2567 12.9481 3.25572 12.9482 3.25488C12.9496 3.2484 12.953 3.23446 12.957 3.2168C12.9655 3.18028 12.9789 3.12222 12.9932 3.06152C13.0075 3.00073 13.0227 2.93642 13.0342 2.8877C13.0399 2.86345 13.0444 2.84259 13.0479 2.82812C13.0495 2.8212 13.0508 2.81541 13.0518 2.81152C13.0522 2.80957 13.0535 2.80765 13.0537 2.80664V2.80469L13.0547 2.80273L13.4854 1.16895C13.5277 0.941915 13.3801 0.740432 13.1768 0.740234H5.01758L5.74121 9.29102ZM3.02051 0.740234C2.75048 0.740341 2.50781 0.990076 2.50781 1.29688V4.79688C2.50781 5.10367 2.75048 5.35341 3.02051 5.35352H4.80078L4.40723 0.740234H3.02051ZM12.9521 3.24121L13.0488 3.26562C13.0402 3.2997 13.0503 3.2584 13.0664 3.18945C13.049 3.18376 13.0313 3.18117 13.0166 3.18262C12.997 3.19105 12.9721 3.21028 12.9658 3.21777C12.9581 3.22809 12.9542 3.23799 12.9541 3.23828C12.9536 3.23941 12.9525 3.24023 12.9521 3.24121ZM12.9502 3.24609C12.9498 3.24721 12.9503 3.24873 12.9502 3.24902C12.9501 3.24921 12.95 3.24763 12.9512 3.24316C12.9507 3.24456 12.9503 3.24563 12.9502 3.24609Z" fill="#9E874A" stroke="#9E874A" stroke-width="0.2" />
                                </svg>
                                <span>{item.mashBill || "Mash bill N/A"}</span>
                              </div>}
                              <div className="barrel-detail-item">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.3837 3.67937C14.3368 3.62321 14.2781 3.57804 14.2118 3.54704C14.1455 3.51605 14.0732 3.49999 14 3.5H3.9175L3.5375 1.41062C3.51657 1.29542 3.45587 1.19121 3.36598 1.11617C3.27609 1.04113 3.16272 1.00002 3.04562 1H1.5C1.36739 1 1.24021 1.05268 1.14645 1.14645C1.05268 1.24021 1 1.36739 1 1.5C1 1.63261 1.05268 1.75979 1.14645 1.85355C1.24021 1.94732 1.36739 2 1.5 2H2.625L4.2225 10.7681C4.26956 11.0282 4.38448 11.2712 4.55562 11.4725C4.3194 11.6931 4.14891 11.9749 4.06304 12.2865C3.97717 12.5981 3.97928 12.9274 4.06914 13.2379C4.15901 13.5484 4.33311 13.828 4.57214 14.0455C4.81117 14.2631 5.1058 14.4103 5.42335 14.4706C5.7409 14.531 6.06896 14.5022 6.37116 14.3875C6.67335 14.2728 6.93788 14.0767 7.1354 13.8208C7.33292 13.5649 7.45572 13.2594 7.49018 12.938C7.52464 12.6166 7.46941 12.2919 7.33063 12H10.1694C10.0575 12.2342 9.99963 12.4905 10 12.75C10 13.0961 10.1026 13.4345 10.2949 13.7222C10.4872 14.01 10.7605 14.2343 11.0803 14.3668C11.4001 14.4992 11.7519 14.5339 12.0914 14.4664C12.4309 14.3989 12.7427 14.2322 12.9874 13.9874C13.2322 13.7427 13.3989 13.4309 13.4664 13.0914C13.5339 12.7519 13.4992 12.4001 13.3668 12.0803C13.2343 11.7605 13.01 11.4872 12.7222 11.2949C12.4345 11.1026 12.0961 11 11.75 11H5.69812C5.58103 11 5.46766 10.9589 5.37777 10.8838C5.28788 10.8088 5.22718 10.7046 5.20625 10.5894L5.00812 9.5H12.2581C12.6094 9.49995 12.9495 9.37661 13.2192 9.15149C13.4889 8.92637 13.671 8.61375 13.7338 8.26812L14.4937 4.08938C14.5066 4.01715 14.5034 3.94298 14.4844 3.87212C14.4654 3.80127 14.431 3.73546 14.3837 3.67937ZM6.5 12.75C6.5 12.8983 6.45601 13.0433 6.3736 13.1667C6.29119 13.29 6.17406 13.3861 6.03701 13.4429C5.89997 13.4997 5.74917 13.5145 5.60368 13.4856C5.4582 13.4566 5.32456 13.3852 5.21967 13.2803C5.11478 13.1754 5.04335 13.0418 5.01441 12.8963C4.98547 12.7508 5.00032 12.6 5.05709 12.463C5.11386 12.3259 5.20999 12.2088 5.33332 12.1264C5.45666 12.044 5.60166 12 5.75 12C5.94891 12 6.13968 12.079 6.28033 12.2197C6.42098 12.3603 6.5 12.5511 6.5 12.75ZM12.5 12.75C12.5 12.8983 12.456 13.0433 12.3736 13.1667C12.2912 13.29 12.1741 13.3861 12.037 13.4429C11.9 13.4997 11.7492 13.5145 11.6037 13.4856C11.4582 13.4566 11.3246 13.3852 11.2197 13.2803C11.1148 13.1754 11.0434 13.0418 11.0144 12.8963C10.9855 12.7508 11.0003 12.6 11.0571 12.463C11.1139 12.3259 11.21 12.2088 11.3333 12.1264C11.4567 12.044 11.6017 12 11.75 12C11.9489 12 12.1397 12.079 12.2803 12.2197C12.421 12.3603 12.5 12.5511 12.5 12.75ZM12.75 8.08937C12.729 8.2049 12.668 8.30935 12.5778 8.38443C12.4875 8.45951 12.3737 8.50042 12.2563 8.5H4.82625L4.09937 4.5H13.4006L12.75 8.08937Z" fill="#9E874A" />
                                </svg>
                                <span>{item.quantity} Quantity</span>
                              </div>
                              <div className="barrel-detail-item">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M15.2069 8.50001L9.00001 2.29313C8.90748 2.19987 8.79735 2.12593 8.67599 2.0756C8.55464 2.02528 8.4245 1.99959 8.29313 2.00001H2.50001C2.3674 2.00001 2.24022 2.05268 2.14645 2.14645C2.05268 2.24022 2.00001 2.3674 2.00001 2.50001V8.29313C1.99959 8.4245 2.02528 8.55464 2.0756 8.67599C2.12593 8.79735 2.19987 8.90748 2.29313 9.00001L8.50001 15.2069C8.59287 15.2998 8.70312 15.3734 8.82446 15.4237C8.9458 15.474 9.07585 15.4999 9.20719 15.4999C9.33853 15.4999 9.46859 15.474 9.58993 15.4237C9.71127 15.3734 9.82152 15.2998 9.91438 15.2069L15.2069 9.91438C15.2998 9.82152 15.3734 9.71127 15.4237 9.58993C15.474 9.46859 15.4999 9.33853 15.4999 9.20719C15.4999 9.07585 15.474 8.9458 15.4237 8.82446C15.3734 8.70312 15.2998 8.59287 15.2069 8.50001ZM9.20688 14.5L3.00001 8.29313V3.00001H8.29313L14.5 9.20688L9.20688 14.5ZM6.00001 5.25001C6.00001 5.39834 5.95602 5.54335 5.87361 5.66668C5.7912 5.79002 5.67406 5.88615 5.53702 5.94291C5.39997 5.99968 5.24917 6.01453 5.10369 5.98559C4.9582 5.95666 4.82456 5.88522 4.71967 5.78034C4.61479 5.67545 4.54335 5.54181 4.51442 5.39632C4.48548 5.25084 4.50033 5.10004 4.5571 4.96299C4.61386 4.82595 4.70999 4.70881 4.83333 4.6264C4.95666 4.54399 5.10167 4.50001 5.25001 4.50001C5.44892 4.50001 5.63968 4.57902 5.78034 4.71967C5.92099 4.86033 6.00001 5.05109 6.00001 5.25001Z" fill="#9E874A" />
                                </svg>
                                <span>{item.listedQuantity} Listed</span>
                              </div>
                              <div className="barrel-detail-item">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_16959_64658)">
                                    <path d="M15.2069 8.50001L9.00001 2.29313C8.90748 2.19987 8.79735 2.12593 8.67599 2.0756C8.55464 2.02528 8.4245 1.99959 8.29313 2.00001H2.50001C2.3674 2.00001 2.24022 2.05268 2.14645 2.14645C2.05506 2.23784 2.00271 2.36096 2.00011 2.48991C2.00004 2.49327 2.00001 2.49664 2.00001 2.50001V3.19271V8.29313C1.99959 8.4245 2.02528 8.55464 2.0756 8.67599C2.12593 8.79735 2.19987 8.90748 2.29313 9.00001L8.50001 15.2069C8.59287 15.2998 8.70312 15.3734 8.82446 15.4237C8.9458 15.474 9.07585 15.4999 9.20719 15.4999C9.33853 15.4999 9.46859 15.474 9.58993 15.4237C9.71127 15.3734 9.82152 15.2998 9.91438 15.2069L11.9643 13.157L12.4291 12.6922L15.2069 9.91438C15.2998 9.82152 15.3734 9.71127 15.4237 9.58993C15.474 9.46859 15.4999 9.33853 15.4999 9.20719C15.4999 9.07585 15.474 8.9458 15.4237 8.82446C15.3734 8.70312 15.2998 8.59287 15.2069 8.50001ZM9.20688 14.5L3.00001 8.29313V4.19271V3.46808V3.00001H8.29313L14.5 9.20688L11.7141 11.9928L11.2571 12.4498L9.20688 14.5ZM6.00001 5.25001C6.00001 5.39834 5.95602 5.54335 5.87361 5.66668C5.7912 5.79002 5.67406 5.88615 5.53702 5.94291C5.53533 5.94361 5.53365 5.9443 5.53196 5.94499C5.39627 6.00004 5.24739 6.01418 5.10369 5.98559C4.9582 5.95666 4.82456 5.88522 4.71968 5.78034C4.61479 5.67545 4.54335 5.54181 4.51442 5.39632C4.48691 5.25802 4.49897 5.11492 4.54899 4.98339C4.55159 4.97656 4.55429 4.96976 4.5571 4.96299C4.61386 4.82595 4.70999 4.70881 4.83333 4.6264C4.95666 4.54399 5.10167 4.50001 5.25001 4.50001C5.44892 4.50001 5.63968 4.57902 5.78034 4.71967C5.92099 4.86033 6.00001 5.05109 6.00001 5.25001Z" fill="#9E874A" />
                                    <path d="M3.00001 3.46808V4.19271L11.2571 12.4498L11.7141 11.9928L5.53196 5.94499C5.39627 6.00004 5.24739 6.01418 5.10369 5.98559C4.9582 5.95666 4.82456 5.88522 4.71968 5.78034C4.61479 5.67545 4.54335 5.54181 4.51442 5.39632C4.48691 5.25802 4.49897 5.11492 4.54899 4.98339L3.00001 3.46808Z" fill="#9E874A" />
                                    <path d="M2.00001 2.50001C2.00001 2.49664 2.00004 2.49327 2.00011 2.48991L0.333333 0.859375L0 1.19271L2.00001 3.19271V2.50001Z" fill="#9E874A" />
                                    <path d="M12.4291 12.6922L11.9643 13.157L15.2069 16.3996L15.6667 15.8594L12.4291 12.6922Z" fill="#9E874A" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_16959_64658">
                                      <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                <span>{item.unlistedQuantity} Unlisted</span>
                              </div>
                              {Number(item?.proof) > 0 && <div className="barrel-detail-item">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.8537 12.4856L9.99806 6.0575V2.5H10.4981C10.6307 2.5 10.7578 2.44732 10.8516 2.35355C10.9454 2.25979 10.9981 2.13261 10.9981 2C10.9981 1.86739 10.9454 1.74021 10.8516 1.64645C10.7578 1.55268 10.6307 1.5 10.4981 1.5H5.49806C5.36545 1.5 5.23828 1.55268 5.14451 1.64645C5.05074 1.74021 4.99806 1.86739 4.99806 2C4.99806 2.13261 5.05074 2.25979 5.14451 2.35355C5.23828 2.44732 5.36545 2.5 5.49806 2.5H5.99806V6.0575L2.14244 12.4856C2.0515 12.6372 2.00238 12.8102 2.00008 12.987C1.99779 13.1638 2.04239 13.338 2.12936 13.4919C2.21632 13.6458 2.34253 13.7739 2.49514 13.8632C2.64774 13.9525 2.82127 13.9997 2.99806 14H12.9981C13.175 14 13.3488 13.953 13.5016 13.8639C13.6545 13.7748 13.781 13.6467 13.8682 13.4927C13.9554 13.3388 14.0001 13.1644 13.9979 12.9875C13.9957 12.8105 13.9466 12.6374 13.8556 12.4856H13.8537ZM6.92681 6.45312C6.97357 6.37561 6.99822 6.28678 6.99806 6.19625V2.5H8.99806V6.19625C8.99791 6.28678 9.02255 6.37561 9.06931 6.45312L11.4581 10.4375C10.7081 10.5856 9.64119 10.5231 8.22369 9.80562C7.22931 9.3025 6.28306 9.03562 5.39744 9.005L6.92681 6.45312ZM2.99806 13L4.78181 10.0262C5.67244 9.9175 6.67619 10.1419 7.77056 10.6962C8.95806 11.2969 9.95806 11.5013 10.7706 11.5013C11.1838 11.5031 11.5952 11.4463 11.9924 11.3325L12.9981 13H2.99806Z" fill="#9E874A" />
                                </svg>
                                <span>{item.proof ? `${item.proof} ${item.proofUnit}` : "0 proof"}</span>
                              </div>}
                              <div className="barrel-detail-item">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_16959_64666)">
                                    <path d="M15 7.5H13.4769C13.3584 6.22007 12.796 5.02188 11.887 4.11296C10.9781 3.20404 9.77993 2.64163 8.5 2.52312V1C8.5 0.867392 8.44732 0.740215 8.35355 0.646447C8.25979 0.552678 8.13261 0.5 8 0.5C7.86739 0.5 7.74021 0.552678 7.64645 0.646447C7.55268 0.740215 7.5 0.867392 7.5 1V2.52312C6.22007 2.64163 5.02188 3.20404 4.11296 4.11296C3.20404 5.02188 2.64163 6.22007 2.52312 7.5H1C0.867392 7.5 0.740215 7.55268 0.646447 7.64645C0.552678 7.74021 0.5 7.86739 0.5 8C0.5 8.13261 0.552678 8.25979 0.646447 8.35355C0.740215 8.44732 0.867392 8.5 1 8.5H2.52312C2.64163 9.77993 3.20404 10.9781 4.11296 11.887C5.02188 12.796 6.22007 13.3584 7.5 13.4769V15C7.5 15.1326 7.55268 15.2598 7.64645 15.3536C7.74021 15.4473 7.86739 15.5 8 15.5C8.13261 15.5 8.25979 15.4473 8.35355 15.3536C8.44732 15.2598 8.5 15.1326 8.5 15V13.4769C9.77993 13.3584 10.9781 12.796 11.887 11.887C12.796 10.9781 13.3584 9.77993 13.4769 8.5H15C15.1326 8.5 15.2598 8.44732 15.3536 8.35355C15.4473 8.25979 15.5 8.13261 15.5 8C15.5 7.86739 15.4473 7.74021 15.3536 7.64645C15.2598 7.55268 15.1326 7.5 15 7.5ZM8 12.5C7.10998 12.5 6.23995 12.2361 5.49993 11.7416C4.75991 11.2471 4.18314 10.5443 3.84254 9.72208C3.50195 8.89981 3.41283 7.99501 3.58647 7.12209C3.7601 6.24918 4.18868 5.44736 4.81802 4.81802C5.44736 4.18868 6.24918 3.7601 7.12209 3.58647C7.99501 3.41283 8.89981 3.50195 9.72208 3.84254C10.5443 4.18314 11.2471 4.75991 11.7416 5.49993C12.2361 6.23995 12.5 7.10998 12.5 8C12.4987 9.19307 12.0241 10.3369 11.1805 11.1805C10.3369 12.0241 9.19307 12.4987 8 12.5ZM8 5.5C7.50555 5.5 7.0222 5.64662 6.61107 5.92133C6.19995 6.19603 5.87952 6.58648 5.6903 7.04329C5.50108 7.50011 5.45157 8.00277 5.54804 8.48773C5.6445 8.97268 5.8826 9.41814 6.23223 9.76777C6.58186 10.1174 7.02732 10.3555 7.51227 10.452C7.99723 10.5484 8.49989 10.4989 8.95671 10.3097C9.41352 10.1205 9.80397 9.80005 10.0787 9.38893C10.3534 8.9778 10.5 8.49445 10.5 8C10.5 7.33696 10.2366 6.70107 9.76777 6.23223C9.29893 5.76339 8.66304 5.5 8 5.5ZM8 9.5C7.70333 9.5 7.41332 9.41203 7.16664 9.2472C6.91997 9.08238 6.72771 8.84811 6.61418 8.57403C6.50065 8.29994 6.47094 7.99834 6.52882 7.70736C6.5867 7.41639 6.72956 7.14912 6.93934 6.93934C7.14912 6.72956 7.41639 6.5867 7.70736 6.52882C7.99834 6.47094 8.29994 6.50065 8.57403 6.61418C8.84811 6.72771 9.08238 6.91997 9.2472 7.16664C9.41203 7.41332 9.5 7.70333 9.5 8C9.5 8.39782 9.34196 8.77936 9.06066 9.06066C8.77936 9.34196 8.39782 9.5 8 9.5Z" fill="#9E874A" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_16959_64666">
                                      <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                <span>{item.facilityName}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {/* GRID VIEW PAGINATION */}
              {tableData.length > 0 && (
                <div className="grid-pagination">

                  {/* First */}
                  <button
                    disabled={page === 0}
                    className="pagination-nav-btn"
                    onClick={() => handlePaginationChange(0)}
                  >
                    ‹‹
                  </button>

                  {/* Prev */}
                  <button
                    disabled={page === 0}
                    className="pagination-nav-btn"
                    onClick={() => handlePaginationChange(page - 1)}
                  >
                    ‹
                  </button>

                  {/* Page buttons */}
                  {pageNumbers.map((p) => (
                    <button
                      key={p}
                      className={page === p ? "active" : ""}
                      onClick={() => handlePaginationChange(p)}
                    >
                      {p + 1}
                    </button>
                  ))}

                  {/* Next */}
                  <button
                    disabled={page === totalPages - 1}
                    className="pagination-nav-btn"
                    onClick={() => handlePaginationChange(page + 1)}
                  >
                    ›
                  </button>

                  {/* Last */}
                  <button
                    disabled={page === totalPages - 1}
                    className="pagination-nav-btn"
                    onClick={() => handlePaginationChange(totalPages - 1)}
                  >
                    ››
                  </button>

                </div>
              )}
            </div>
          ) : (
            <>
              {activeButtonRef.current === "barrels" && (
                <HorizontalScrollIndicator>
                  <DataGrid
                    sortingMode="server"
                    sortModel={sortModel}
                    onSortModelChange={handleSortChange}
                    rows={tableDataWithIds}
                    columns={containerColumns}
                    className="data-grid data-grid__myinventories"
                    initialState={{
                      pagination: {
                        paginationModel: { page, pageSize },
                      },
                    }}
                    pagination
                    paginationMode="server"
                    paginationModel={{ page, pageSize }}
                    // onSortModelChange={handleSortChange}
                    onPaginationModelChange={onPaginationModelChange}
                    pageSizeOptions={[10, 20, 50, 100]}
                    rowCount={totalCount}
                    disableRowSelectionOnClick={true}
                    onRowClick={(params) => {
                        if (CommonService.isAdmin()) {
                            handleContainerViewBarrelClick(params);
                        }
                    }}
                    loading={containerLoading}
                    slots={{
                      loadingOverlay: DataGridLoader,
                    }}
                    disableColumnResize
                    onRowSelectionModelChange={handleSelectionModelChange}
                    sx={{
                      "& .MuiDataGrid-columnHeaderCheckbox": {
                        borderBottom: "unset !important"
                      },
                    }}                   
                    columnVisibilityModel={{
                        lotNo: false,
                        barrelNumber: false,
                        proof: false,
                        proofGallons: false
                    }}
                  />
                </HorizontalScrollIndicator>
              )}

              {activeButtonRef.current === "barrel_lots" && (
                <HorizontalScrollIndicator>
                  <DataGrid
                    sortingMode="server"
                    sortModel={sortModel}
                    onSortModelChange={handleSortChange}
                    rows={tableDataWithIds}
                    columns={containerLotColumns}
                    className="data-grid data-grid__myinventories"
                    initialState={{
                      pagination: {
                        paginationModel: { page, pageSize },
                      },
                    }}
                    pagination
                    paginationMode="server"
                    paginationModel={{ page, pageSize }}
                    // onSortModelChange={handleSortChange}
                    onPaginationModelChange={onPaginationModelChange}
                    pageSizeOptions={[10, 20, 50, 100]}
                    rowCount={totalCount}
                    disableRowSelectionOnClick={true}
                    loading={containerLoading}
                    slots={{
                      loadingOverlay: DataGridLoader,
                    }}
                    disableColumnResize
                    {...((activeButtonRef.current === "barrel_lots") && {
                      rowSelectionModel: selectionModel,
                      checkboxSelection: true,
                      keepNonExistentRowsSelected: true
                    })}
                    onRowSelectionModelChange={handleSelectionModelChange}
                    sx={{
                      "& .MuiDataGrid-columnHeaderCheckbox": {
                        borderBottom: "unset !important"
                      },
                    }}
                    columnVisibilityModel={{
                        lotNo: false,
                        fillDate: false
                    }}
                  />
                </HorizontalScrollIndicator>
              )}

              {activeButtonRef.current === "product" && (
                <HorizontalScrollIndicator>
                  <DataGrid
                    sortingMode="server"
                    sortModel={sortModel}
                    onSortModelChange={handleSortChange}
                    rows={tableDataWithIds}
                    columns={productColumns}
                    getRowId={(row) => row.id}
                    className="data-grid data-grid__myinventories"
                    initialState={{
                      pagination: {
                        paginationModel: { page, pageSize },
                      },
                    }}
                    pagination
                    paginationMode="server"
                    paginationModel={{ page, pageSize }}
                    // onSortModelChange={handleSortChange}
                    onPaginationModelChange={onPaginationModelChange}
                    pageSizeOptions={[10, 20, 50, 100]}
                    rowCount={totalCount}
                    disableRowSelectionOnClick={true}
                    loading={productLoading}
                    slots={{
                      loadingOverlay: DataGridLoader,
                    }}
                    disableColumnResize
                    onRowSelectionModelChange={handleSelectionModelChange}
                    sx={{
                      "& .MuiDataGrid-columnHeaderCheckbox": {
                        borderBottom: "unset !important"
                      },
                    }}
                  />
                </HorizontalScrollIndicator>
              )}

              {activeButtonRef.current === "facilities" && (
                <HorizontalScrollIndicator>
                  <DataGrid
                    sortingMode="server"
                    sortModel={sortModel}
                    onSortModelChange={handleSortChange}
                    rows={tableDataWithIds}
                    columns={facilitiesColumns}
                    getRowId={(row) => row.id}
                    className="data-grid data-grid__myinventories"
                    initialState={{
                      pagination: {
                        paginationModel: { page, pageSize },
                      },
                    }}
                    pagination
                    paginationMode="server"
                    paginationModel={{ page, pageSize }}
                    // onSortModelChange={handleSortChange}
                    onPaginationModelChange={onPaginationModelChange}
                    pageSizeOptions={[10, 20, 50, 100]}
                    rowCount={totalCount}
                    disableRowSelectionOnClick={true}
                    loading={facilityLoading}
                    slots={{
                      loadingOverlay: DataGridLoader,
                    }}
                    disableColumnResize
                    onRowSelectionModelChange={handleSelectionModelChange}
                    sx={{
                      "& .MuiDataGrid-columnHeaderCheckbox": {
                        borderBottom: "unset !important"
                      },
                    }}
                  />
                </HorizontalScrollIndicator>
              )}
            </>
          )
          }
        </div>
      </div>
    </div>
  );
};

export default MyInventories;
